import { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API, getAuthHeader } from '../App';
import axios from 'axios';
import { toast } from 'sonner';
import { 
  MessageCircle, Send, Phone, X, CheckCircle, Clock, 
  Tag, Users, ArrowRightLeft, FileText, AlertTriangle,
  Zap, History, Bell, Search, Filter, MoreVertical,
  Volume2, VolumeX, UserPlus, RefreshCw, Eye, EyeOff,
  AlertCircle, Inbox, User, ChevronDown, Trash2, Star,
  MessageSquare, Archive, ArrowLeft, Menu, PanelLeftClose, Loader2,
  Download, Mail, Printer, Mic, Square, Loader, Edit2, Save, Radio,
  Paperclip, Image
} from 'lucide-react';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

// Som de notificação
var notificationSound = null;
function playNotificationSound() {
  if (!notificationSound) {
    try {
      notificationSound = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdH2JkIqGgX16d3V3eoCHi42LiYaDgH58fH6AhIiLjY2LiYaDgH58fH6AhIiLjY2LiYaDgH58');
    } catch (e) {}
  }
  if (notificationSound) {
    notificationSound.play().catch(function() {});
  }
}

// Componente de Item de Atendimento
function AtendimentoItem(props) {
  var atendimento = props.atendimento;
  var isSelected = props.isSelected;
  var onClick = props.onClick;

  function getStatusColor(s) {
    if (s === 'em_atendimento') return 'bg-blue-100 text-blue-700';
    if (s === 'finalizado') return 'bg-green-100 text-green-700';
    if (s === 'aguardando_atendente') return 'bg-red-100 text-red-700';
    return 'bg-orange-100 text-orange-700';
  }
  
  function getStatusLabel(s) {
    if (s === 'em_atendimento') return 'Em Atendimento';
    if (s === 'finalizado') return 'Finalizado';
    if (s === 'aguardando_atendente') return 'Aguardando Atendente';
    return 'Aguardando';
  }

  function getPrioridadeColor(p) {
    if (p === 'urgente') return 'border-l-4 border-l-red-500';
    if (p === 'alta') return 'border-l-4 border-l-orange-500';
    if (p === 'baixa') return 'border-l-4 border-l-slate-300';
    return 'border-l-4 border-l-blue-300';
  }

  function formatTempo(dataStr) {
    if (!dataStr) return '';
    var data = new Date(dataStr);
    var agora = new Date();
    var diff = Math.floor((agora - data) / 60000);
    if (diff < 1) return 'Agora';
    if (diff < 60) return diff + 'min';
    if (diff < 1440) return Math.floor(diff / 60) + 'h';
    return Math.floor(diff / 1440) + 'd';
  }

  var naoLidas = atendimento.nao_lidas || 0;
  var isEsquecido = false;
  if (atendimento.updated_at) {
    var lastUpdate = new Date(atendimento.updated_at);
    var diff = (new Date() - lastUpdate) / 60000;
    isEsquecido = diff > 30 && atendimento.status !== 'finalizado';
  }

  return (
    <div 
      onClick={onClick}
      data-testid={'atendimento-item-' + atendimento.id}
      className={'bg-white rounded-lg p-3 cursor-pointer hover:shadow-md transition-all ' + getPrioridadeColor(atendimento.prioridade) + ' ' + (isSelected ? 'ring-2 ring-blue-500 shadow-md' : 'border') + ' ' + (isEsquecido ? 'bg-red-50' : '')}
    >
      <div className="flex items-start justify-between mb-2">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2">
            <p className="font-medium text-slate-800 truncate">{atendimento.nome || atendimento.telefone}</p>
            {naoLidas > 0 && (
              <span className="bg-red-500 text-white text-xs px-1.5 py-0.5 rounded-full animate-pulse">{naoLidas}</span>
            )}
            {isEsquecido && (
              <AlertCircle className="w-4 h-4 text-red-500" />
            )}
          </div>
          <p className="text-slate-500 text-xs flex items-center gap-1">
            <Phone className="w-3 h-3" />{atendimento.telefone}
          </p>
          {atendimento.operador_nome && (
            <p className="text-xs text-blue-600 flex items-center gap-1 mt-1">
              <User className="w-3 h-3" />{atendimento.operador_nome}
            </p>
          )}
        </div>
        <div className="flex flex-col items-end gap-1">
          <span className={'text-xs px-2 py-0.5 rounded-full ' + getStatusColor(atendimento.status)}>
            {getStatusLabel(atendimento.status)}
          </span>
          <span className="text-xs text-slate-400">{formatTempo(atendimento.created_at)}</span>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1 flex-wrap">
          <span className="text-xs text-slate-400">#{atendimento.protocolo}</span>
          {atendimento.categoria && (
            <span className="text-xs bg-slate-100 text-slate-600 px-1.5 py-0.5 rounded">{atendimento.categoria}</span>
          )}
          {atendimento.filial && (
            <span 
              className="text-xs text-white px-1.5 py-0.5 rounded font-medium"
              style={{ backgroundColor: atendimento.filial_cor || '#6b7280' }}
            >
              {atendimento.filial_sigla || atendimento.filial}
            </span>
          )}
          {atendimento.aguardando_filial && (
            <span className="text-xs bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded animate-pulse">
              Selecionando Filial
            </span>
          )}
        </div>
        {atendimento.canal === 'whatsapp' && (
          <MessageSquare className="w-4 h-4 text-green-500" />
        )}
      </div>
    </div>
  );
}

// Componente de Bolha de Mensagem
function MensagemBubble(props) {
  var msg = props.msg;
  var onResponder = props.onResponder;
  var onEditar = props.onEditar;
  var isCliente = msg.remetente === 'cliente';
  var isOperador = msg.remetente === 'operador';
  var isSistema = msg.remetente === 'sistema';
  var podeEditar = isOperador || isSistema; // Pode editar mensagens do operador ou sistema
  var showMenuState = useState(false);
  var showMenu = showMenuState[0];
  var setShowMenu = showMenuState[1];
  var editandoState = useState(false);
  var editando = editandoState[0];
  var setEditando = editandoState[1];
  var textoEditadoState = useState(msg.mensagem || '');
  var textoEditado = textoEditadoState[0];
  var setTextoEditado = textoEditadoState[1];
  
  var bubbleClass = 'bg-slate-200 text-slate-700 rounded-br-sm';
  if (isCliente) bubbleClass = 'bg-white border rounded-bl-sm';
  else if (isOperador || isSistema) bubbleClass = 'bg-blue-600 text-white rounded-br-sm';

  // Formatar timestamp
  function formatarHorario(timestamp) {
    if (!timestamp) return '';
    try {
      var data = new Date(timestamp);
      if (isNaN(data.getTime())) return '';
      var hoje = new Date();
      var mesmodia = data.toDateString() === hoje.toDateString();
      var horas = data.getHours().toString().padStart(2, '0');
      var minutos = data.getMinutes().toString().padStart(2, '0');
      if (mesmodia) {
        return horas + ':' + minutos;
      } else {
        var dia = data.getDate().toString().padStart(2, '0');
        var mes = (data.getMonth() + 1).toString().padStart(2, '0');
        return dia + '/' + mes + ' ' + horas + ':' + minutos;
      }
    } catch (e) {
      return '';
    }
  }
  
  function handleResponder() {
    if (onResponder) {
      onResponder(msg);
    }
    setShowMenu(false);
  }
  
  function copiarMensagem() {
    var texto = msg.mensagem || '';
    navigator.clipboard.writeText(texto).then(function() {
      // Feedback visual poderia ser adicionado aqui
    });
    setShowMenu(false);
  }
  
  function iniciarEdicao() {
    setTextoEditado(msg.mensagem || '');
    setEditando(true);
    setShowMenu(false);
  }
  
  function salvarEdicao() {
    if (onEditar && textoEditado.trim()) {
      onEditar(msg, textoEditado.trim());
    }
    setEditando(false);
  }
  
  function cancelarEdicao() {
    setTextoEditado(msg.mensagem || '');
    setEditando(false);
  }

  // Renderizar conteúdo baseado no tipo
  function renderConteudo() {
    var tipo = msg.tipo || 'texto';
    
    // Áudio
    if (tipo === 'audio' || msg.audio_url || msg.audio_base64) {
      var audioSrc = msg.audio_url || (msg.audio_base64 ? 'data:audio/ogg;base64,' + msg.audio_base64 : null);
      
      if (audioSrc) {
        return (
          <div className="flex items-center gap-2">
            <audio 
              controls 
              src={audioSrc}
              className="max-w-full h-10"
              style={{ minWidth: '200px' }}
            >
              Seu navegador não suporta áudio.
            </audio>
          </div>
        );
      } else {
        return <p className="text-sm italic">🎤 Áudio (não disponível para reprodução)</p>;
      }
    }
    
    // Imagem
    if (tipo === 'imagem' || tipo === 'image' || msg.imagem_url || msg.image_url) {
      var imgSrc = msg.imagem_url || msg.image_url || msg.imageUrl;
      if (imgSrc) {
        return (
          <img 
            src={imgSrc} 
            alt="Imagem" 
            className="max-w-full rounded-lg cursor-pointer"
            style={{ maxHeight: '200px' }}
            onClick={function() { window.open(imgSrc, '_blank'); }}
          />
        );
      }
    }
    
    // Documento
    if (tipo === 'documento' || tipo === 'document' || msg.documento_url || msg.document_url) {
      var docUrl = msg.documento_url || msg.document_url || msg.documentUrl;
      var docNome = msg.documento_nome || msg.document_name || 'Documento';
      if (docUrl) {
        return (
          <a 
            href={docUrl} 
            target="_blank" 
            rel="noopener noreferrer"
            className={'flex items-center gap-2 ' + (isOperador ? 'text-blue-100 hover:text-white' : 'text-blue-600 hover:text-blue-800')}
          >
            📄 {docNome}
          </a>
        );
      }
    }
    
    // Texto padrão
    return <p className="whitespace-pre-line text-sm">{msg.mensagem}</p>;
  }

  return (
    <div 
      className={'flex group relative ' + (isCliente ? 'justify-start' : 'justify-end')}
      onMouseEnter={function() { setShowMenu(true); }}
      onMouseLeave={function() { setShowMenu(false); }}
    >
      {/* Botões de ação - aparecem no hover */}
      {showMenu && !isOperador && (
        <div className={'flex items-center gap-1 absolute top-1 ' + (isCliente ? 'right-2' : 'left-2')}>
          <button
            onClick={handleResponder}
            className="p-1.5 bg-white rounded-full shadow-md hover:bg-slate-100 transition-colors"
            title="Responder"
          >
            <ArrowLeft className="w-3.5 h-3.5 text-slate-600 rotate-180" />
          </button>
          <button
            onClick={copiarMensagem}
            className="p-1.5 bg-white rounded-full shadow-md hover:bg-slate-100 transition-colors"
            title="Copiar"
          >
            <FileText className="w-3.5 h-3.5 text-slate-600" />
          </button>
        </div>
      )}
      {showMenu && podeEditar && (
        <div className={'flex items-center gap-1 absolute top-1 ' + (isCliente ? 'right-2' : 'left-2')}>
          <button
            onClick={iniciarEdicao}
            className="p-1.5 bg-white rounded-full shadow-md hover:bg-slate-100 transition-colors"
            title="Editar"
          >
            <Edit2 className="w-3.5 h-3.5 text-slate-600" />
          </button>
          <button
            onClick={copiarMensagem}
            className="p-1.5 bg-white rounded-full shadow-md hover:bg-slate-100 transition-colors"
            title="Copiar"
          >
            <FileText className="w-3.5 h-3.5 text-slate-600" />
          </button>
        </div>
      )}
      {/* Modo de edição */}
      {editando ? (
        <div className="max-w-[70%] bg-white rounded-2xl px-4 py-3 border-2 border-blue-400 shadow-lg">
          <p className="text-xs text-slate-500 mb-2">Editando mensagem:</p>
          <textarea
            className="w-full p-2 border rounded text-sm resize-none"
            rows={3}
            value={textoEditado}
            onChange={function(e) { setTextoEditado(e.target.value); }}
            autoFocus
          />
          <div className="flex justify-end gap-2 mt-2">
            <button
              onClick={cancelarEdicao}
              className="px-3 py-1 text-xs bg-slate-200 rounded hover:bg-slate-300"
            >
              Cancelar
            </button>
            <button
              onClick={salvarEdicao}
              className="px-3 py-1 text-xs bg-blue-600 text-white rounded hover:bg-blue-700"
            >
              Salvar
            </button>
          </div>
        </div>
      ) : (
      <div className={'max-w-[70%] rounded-2xl px-4 py-2 cursor-pointer hover:opacity-95 ' + bubbleClass} onClick={function() { if (!isOperador && onResponder) handleResponder(); }}>
        <div className="flex items-center justify-between gap-2 mb-1">
          <p className={'text-xs ' + (isOperador ? 'text-blue-200' : 'text-slate-400')}>
            {msg.nome_remetente}
          </p>
          <div className="flex items-center gap-1">
            <span className={'text-xs ' + (isOperador ? 'text-blue-200' : 'text-slate-400')}>
              {formatarHorario(msg.timestamp)}
            </span>
            {/* Indicador de status de entrega */}
            {(isOperador || isSistema) && (
              <span className={'text-xs ' + (isOperador ? 'text-blue-200' : 'text-slate-400')}>
                {msg.status_entrega === 'lido' ? (
                  <span title="Lido" className="text-blue-300">✓✓</span>
                ) : msg.status_entrega === 'entregue' ? (
                  <span title="Entregue">✓✓</span>
                ) : (
                  <span title="Enviado">✓</span>
                )}
              </span>
            )}
          </div>
        </div>
        {/* Mostrar mensagem citada se houver */}
        {msg.citacao && (
          <div className={'mb-2 pl-2 border-l-2 ' + (isOperador ? 'border-blue-300' : 'border-slate-400')}>
            <p className={'text-xs font-medium ' + (isOperador ? 'text-blue-200' : 'text-slate-500')}>
              {msg.citacao.nome_remetente}
            </p>
            <p className={'text-xs truncate ' + (isOperador ? 'text-blue-100' : 'text-slate-400')}>
              {msg.citacao.mensagem && msg.citacao.mensagem.substring(0, 50)}...
            </p>
          </div>
        )}
        {renderConteudo()}
        {/* Mostrar indicador de editada */}
        {msg.editada && (
          <p className={'text-xs mt-1 italic ' + ((isOperador || isSistema) ? 'text-blue-200' : 'text-slate-400')}>
            (editada)
          </p>
        )}
      </div>
      )}
    </div>
  );
}

// Componente de Painel de Chat - VERSÃO PROFISSIONAL
function ChatPanel(props) {
  var selected = props.selected;
  var resposta = props.resposta;
  var setResposta = props.setResposta;
  var enviarResposta = props.enviarResposta;
  var assumir = props.assumir;
  var finalizar = props.finalizar;
  var onClose = props.onClose;
  var respostasRapidas = props.respostasRapidas;
  var operadores = props.operadores;
  var onTransferir = props.onTransferir;
  // onBuscarBoleto removido - novo fluxo com confirmação implementado internamente
  var onAtualizarPrioridade = props.onAtualizarPrioridade;
  var isMobile = props.isMobile;
  var onVoltar = props.onVoltar;
  var exportando = props.exportando;
  var onExportar = props.onExportar;

  var messagesEndRef = useRef(null);
  var showRespostasState = useState(false);
  var showRespostas = showRespostasState[0];
  var setShowRespostas = showRespostasState[1];
  var showTransferirState = useState(false);
  var showTransferir = showTransferirState[0];
  var setShowTransferir = showTransferirState[1];
  var cpfBoletoState = useState('');
  var cpfBoleto = cpfBoletoState[0];
  var setCpfBoleto = cpfBoletoState[1];
  var showBoletoState = useState(false);
  var showBoleto = showBoletoState[0];
  var setShowBoleto = showBoletoState[1];
  var clientesBoletoState = useState([]);
  var clientesBoleto = clientesBoletoState[0];
  var setClientesBoleto = clientesBoletoState[1];
  var buscandoBoletoState = useState(false);
  var buscandoBoleto = buscandoBoletoState[0];
  var setBuscandoBoleto = buscandoBoletoState[1];
  var clienteSelecionadoBoletoState = useState(null);
  var clienteSelecionadoBoleto = clienteSelecionadoBoletoState[0];
  var setClienteSelecionadoBoleto = clienteSelecionadoBoletoState[1];
  var showPrioridadeState = useState(false);
  var showPrioridade = showPrioridadeState[0];
  var setShowPrioridade = showPrioridadeState[1];
  var showNotasState = useState(false);
  var showNotas = showNotasState[0];
  var setShowNotas = showNotasState[1];
  var notaInternaState = useState('');
  var notaInterna = notaInternaState[0];
  var setNotaInterna = notaInternaState[1];
  var showClienteInfoState = useState(false);
  var showClienteInfo = showClienteInfoState[0];
  var setShowClienteInfo = showClienteInfoState[1];
  
  // Estados para edição de contato
  var editandoContatoState = useState(false);
  var editandoContato = editandoContatoState[0];
  var setEditandoContato = editandoContatoState[1];
  var dadosContatoState = useState({ nome: '', email: '', cpf_cnpj: '', endereco: '' });
  var dadosContato = dadosContatoState[0];
  var setDadosContato = dadosContatoState[1];
  var salvandoContatoState = useState(false);
  var salvandoContato = salvandoContatoState[0];
  var setSalvandoContato = salvandoContatoState[1];
  
  // Estados para gravação de áudio
  var gravandoAudioState = useState(false);
  var gravandoAudio = gravandoAudioState[0];
  var setGravandoAudio = gravandoAudioState[1];
  var enviandoAudioState = useState(false);
  var enviandoAudio = enviandoAudioState[0];
  var setEnviandoAudio = enviandoAudioState[1];
  var mediaRecorderRef = useRef(null);
  var audioChunksRef = useRef([]);
  var tempoGravacaoState = useState(0);
  var tempoGravacao = tempoGravacaoState[0];
  var setTempoGravacao = tempoGravacaoState[1];
  var timerRef = useRef(null);
  
  // Estado para envio de arquivos
  var enviandoArquivoState = useState(false);
  var enviandoArquivo = enviandoArquivoState[0];
  var setEnviandoArquivo = enviandoArquivoState[1];
  var fileInputRef = useRef(null);
  
  // Mensagem citada vem das props
  var mensagemCitada = props.mensagemCitada;
  var setMensagemCitada = props.setMensagemCitada;

  // Scroll automático para última mensagem quando mensagens mudam
  useEffect(function() {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [selected ? selected.mensagens?.length : 0]); // Observa o número de mensagens

  function handleEnviar(e) {
    e.preventDefault();
    if (!resposta.trim()) return;
    enviarResposta();
  }

  // Funções de gravação de áudio
  function iniciarGravacao() {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
      toast.error('Seu navegador não suporta gravação de áudio');
      return;
    }
    
    navigator.mediaDevices.getUserMedia({ audio: true })
      .then(function(stream) {
        audioChunksRef.current = [];
        
        // Detectar formato suportado
        var mimeType = 'audio/webm';
        if (MediaRecorder.isTypeSupported('audio/webm;codecs=opus')) {
          mimeType = 'audio/webm;codecs=opus';
        } else if (MediaRecorder.isTypeSupported('audio/webm')) {
          mimeType = 'audio/webm';
        } else if (MediaRecorder.isTypeSupported('audio/mp4')) {
          mimeType = 'audio/mp4';
        } else if (MediaRecorder.isTypeSupported('audio/ogg')) {
          mimeType = 'audio/ogg';
        } else {
          // Usar padrão do navegador
          mimeType = undefined;
        }
        
        var options = mimeType ? { mimeType: mimeType } : {};
        var mediaRecorder;
        
        try {
          mediaRecorder = new MediaRecorder(stream, options);
        } catch (e) {
          console.warn('Erro com mimeType, tentando sem:', e);
          mediaRecorder = new MediaRecorder(stream);
        }
        
        mediaRecorderRef.current = mediaRecorder;
        
        mediaRecorder.ondataavailable = function(event) {
          if (event.data.size > 0) {
            audioChunksRef.current.push(event.data);
          }
        };
        
        mediaRecorder.onstop = function() {
          stream.getTracks().forEach(function(track) { track.stop(); });
        };
        
        mediaRecorder.onerror = function(event) {
          console.error('Erro no MediaRecorder:', event.error);
          toast.error('Erro na gravação de áudio');
          setGravandoAudio(false);
        };
        
        // Solicitar dados a cada 1 segundo para não perder nada
        mediaRecorder.start(1000);
        setGravandoAudio(true);
        setTempoGravacao(0);
        toast.success('Gravando...');
        
        // Timer para mostrar tempo de gravação
        timerRef.current = setInterval(function() {
          setTempoGravacao(function(prev) { return prev + 1; });
        }, 1000);
      })
      .catch(function(err) {
        console.error('Erro ao acessar microfone:', err);
        if (err.name === 'NotAllowedError' || err.name === 'PermissionDeniedError') {
          toast.error('Permissão de microfone negada. Habilite nas configurações do navegador.');
        } else if (err.name === 'NotFoundError') {
          toast.error('Nenhum microfone encontrado no dispositivo.');
        } else {
          toast.error('Erro ao acessar microfone: ' + err.message);
        }
      });
  }
  
  function pararGravacao() {
    if (mediaRecorderRef.current && gravandoAudio) {
      mediaRecorderRef.current.stop();
      setGravandoAudio(false);
      
      if (timerRef.current) {
        clearInterval(timerRef.current);
        timerRef.current = null;
      }
      
      // Aguardar um pouco para os chunks serem processados
      setTimeout(function() {
        enviarAudio();
      }, 100);
    }
  }
  
  function cancelarGravacao() {
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
    }
    setGravandoAudio(false);
    setTempoGravacao(0);
    audioChunksRef.current = [];
    
    if (timerRef.current) {
      clearInterval(timerRef.current);
      timerRef.current = null;
    }
  }
  
  function enviarAudio() {
    if (audioChunksRef.current.length === 0) {
      toast.error('Nenhum áudio gravado');
      return;
    }
    
    setEnviandoAudio(true);
    
    // Usar o tipo do primeiro chunk (que foi definido pelo MediaRecorder)
    var mimeType = audioChunksRef.current[0].type || 'audio/webm';
    var audioBlob = new Blob(audioChunksRef.current, { type: mimeType });
    
    console.log('Enviando áudio:', audioBlob.size, 'bytes, tipo:', mimeType);
    
    // Converter para base64
    var reader = new FileReader();
    reader.onloadend = function() {
      var base64Audio = reader.result.split(',')[1];
      
      if (!base64Audio) {
        toast.error('Erro ao processar áudio');
        setEnviandoAudio(false);
        return;
      }
      
      axios.post(
        API + '/atendimentos/' + selected.id + '/enviar-audio',
        { audio_base64: base64Audio },
        { headers: getAuthHeader() }
      ).then(function() {
        toast.success('Áudio enviado!');
        setEnviandoAudio(false);
        audioChunksRef.current = [];
        setTempoGravacao(0);
      }).catch(function(err) {
        console.error('Erro ao enviar áudio:', err);
        toast.error(err.response?.data?.detail || 'Erro ao enviar áudio');
        setEnviandoAudio(false);
      });
    };
    
    reader.onerror = function() {
      toast.error('Erro ao processar áudio');
      setEnviandoAudio(false);
    };
    
    reader.readAsDataURL(audioBlob);
  }
  
  function formatarTempoGravacao(segundos) {
    var mins = Math.floor(segundos / 60);
    var secs = segundos % 60;
    return mins.toString().padStart(2, '0') + ':' + secs.toString().padStart(2, '0');
  }

  // Função para enviar arquivo/imagem
  function handleFileSelect(e) {
    var file = e.target.files[0];
    if (!file) return;
    
    // Verificar tamanho (max 16MB)
    if (file.size > 16 * 1024 * 1024) {
      toast.error('Arquivo muito grande. Máximo 16MB.');
      return;
    }
    
    setEnviandoArquivo(true);
    
    var formData = new FormData();
    formData.append('file', file);
    formData.append('caption', '');
    
    // Determinar se é imagem ou documento
    var isImage = file.type.startsWith('image/');
    var endpoint = isImage ? '/enviar-imagem' : '/enviar-arquivo';
    
    axios.post(
      API + '/atendimentos/' + selected.id + endpoint,
      formData,
      { 
        headers: { 
          ...getAuthHeader(),
          'Content-Type': 'multipart/form-data'
        }
      }
    ).then(function(res) {
      toast.success(isImage ? 'Imagem enviada!' : 'Arquivo enviado!');
      setEnviandoArquivo(false);
      // Limpar o input
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
      // Recarregar mensagens
      if (typeof refreshChat === 'function') {
        refreshChat();
      }
    }).catch(function(err) {
      console.error('Erro ao enviar arquivo:', err);
      toast.error(err.response?.data?.detail || 'Erro ao enviar arquivo');
      setEnviandoArquivo(false);
    });
  }

  // Funções para editar contato
  function iniciarEdicaoContato() {
    setDadosContato({
      nome: selected.nome || '',
      telefone: selected.telefone || '',
      email: selected.email || '',
      cpf_cnpj: selected.cpf_cnpj || '',
      endereco: selected.endereco || ''
    });
    setEditandoContato(true);
  }

  function cancelarEdicaoContato() {
    setEditandoContato(false);
    setDadosContato({ nome: '', telefone: '', email: '', cpf_cnpj: '', endereco: '' });
  }

  function salvarContato() {
    if (!dadosContato.nome.trim()) {
      toast.error('Nome é obrigatório');
      return;
    }
    
    setSalvandoContato(true);
    axios.put(
      API + '/atendimentos/' + selected.id + '/contato',
      dadosContato,
      { headers: getAuthHeader() }
    ).then(function(res) {
      toast.success('Contato atualizado!');
      setEditandoContato(false);
      // Atualizar o selected com os novos dados
      setSelected(function(prev) {
        return { ...prev, nome: dadosContato.nome, telefone: dadosContato.telefone || prev.telefone, email: dadosContato.email, cpf_cnpj: dadosContato.cpf_cnpj, endereco: dadosContato.endereco };
      });
      // Atualizar na lista também
      setAtendimentos(function(prev) {
        return prev.map(function(a) {
          if (a.id === selected.id) {
            return { ...a, nome: dadosContato.nome, telefone: dadosContato.telefone || a.telefone };
          }
          return a;
        });
      });
      setSalvandoContato(false);
    }).catch(function(err) {
      toast.error(err.response?.data?.detail || 'Erro ao salvar contato');
      setSalvandoContato(false);
    });
  }

  function handleBuscarClientes() {
    if (!cpfBoleto || cpfBoleto.trim().length < 3) {
      toast.error('Digite pelo menos 3 caracteres para buscar');
      return;
    }
    
    setBuscandoBoleto(true);
    setClientesBoleto([]);
    setClienteSelecionadoBoleto(null);
    
    axios.get(
      API + '/atendimentos/' + selected.id + '/buscar-clientes-boleto?termo=' + encodeURIComponent(cpfBoleto.trim()),
      { headers: getAuthHeader() }
    ).then(function(res) {
      setBuscandoBoleto(false);
      if (res.data.clientes && res.data.clientes.length > 0) {
        setClientesBoleto(res.data.clientes);
        toast.success(res.data.total + ' cliente(s) encontrado(s)');
      } else {
        setClientesBoleto([]);
        toast.error('Nenhum cliente encontrado com: ' + cpfBoleto);
      }
    }).catch(function(err) {
      setBuscandoBoleto(false);
      toast.error('Erro ao buscar clientes');
    });
  }

  function confirmarEnvioBoleto(cliente) {
    if (!cliente) return;
    
    var cpfParaBuscar = cliente.cpf_cnpj || cliente.ixc_id;
    if (!cpfParaBuscar) {
      toast.error('Cliente sem CPF/CNPJ válido');
      return;
    }
    
    // Confirmação adicional
    var mensagemConfirmacao = 'Confirma envio de boleto para:\n\n' +
      'Nome: ' + (cliente.nome || 'N/A') + '\n' +
      'CPF/CNPJ: ' + (cliente.cpf_cnpj || 'N/A') + '\n' +
      'Plano: ' + (cliente.plano || 'N/A') + '\n\n' +
      'Deseja continuar?';
    
    if (window.confirm(mensagemConfirmacao)) {
      // Chamar o endpoint de buscar boleto
      axios.post(
        API + '/atendimentos/' + selected.id + '/buscar-boleto?cpf_cnpj=' + encodeURIComponent(cpfParaBuscar),
        {},
        { headers: getAuthHeader() }
      ).then(function(res) {
        if (res.data.success) {
          toast.success('Boleto encontrado e enviado para o cliente!');
        } else {
          toast.error(res.data.message || 'Erro ao buscar boleto');
        }
        // Limpar formulário
        setClientesBoleto([]);
        setClienteSelecionadoBoleto(null);
        setCpfBoleto('');
        setShowBoleto(false);
      }).catch(function(err) {
        toast.error('Erro ao buscar boleto');
      });
    }
  }

  function handleFinalizarClick() {
    finalizar(selected.id);
  }

  function getTempoAtendimento() {
    if (!selected || !selected.created_at) return '00:00';
    var inicio = new Date(selected.created_at);
    var agora = new Date();
    var diff = Math.floor((agora - inicio) / 1000);
    var horas = Math.floor(diff / 3600);
    var minutos = Math.floor((diff % 3600) / 60);
    return (horas < 10 ? '0' : '') + horas + ':' + (minutos < 10 ? '0' : '') + minutos;
  }

  function getStatusInfo(status) {
    if (status === 'em_atendimento') return { label: 'Em Atendimento', color: 'bg-blue-500', icon: MessageCircle };
    if (status === 'finalizado') return { label: 'Finalizado', color: 'bg-green-500', icon: CheckCircle };
    if (status === 'aguardando_atendente') return { label: 'Aguardando Atendente', color: 'bg-red-500', icon: AlertCircle };
    return { label: 'Aguardando', color: 'bg-orange-500', icon: Clock };
  }

  function getPrioridadeInfo(prioridade) {
    if (prioridade === 'urgente') return { label: 'Urgente', color: 'bg-red-500 text-white' };
    if (prioridade === 'alta') return { label: 'Alta', color: 'bg-orange-500 text-white' };
    if (prioridade === 'baixa') return { label: 'Baixa', color: 'bg-slate-400 text-white' };
    return { label: 'Normal', color: 'bg-blue-500 text-white' };
  }

  if (!selected) {
    return (
      <div className={'flex-1 flex items-center justify-center bg-gradient-to-br from-slate-100 to-slate-200 rounded-xl ' + (isMobile ? 'hidden' : '')}>
        <div className="text-center text-slate-400">
          <div className="w-24 h-24 mx-auto mb-6 bg-white rounded-full flex items-center justify-center shadow-lg">
            <MessageCircle className="w-12 h-12 text-slate-300" />
          </div>
          <p className="text-xl font-medium text-slate-500">Selecione um atendimento</p>
          <p className="text-sm text-slate-400 mt-2">Escolha uma conversa ao lado para começar</p>
        </div>
      </div>
    );
  }

  var mensagens = selected.mensagens || [];
  var statusInfo = getStatusInfo(selected.status);
  var StatusIcon = statusInfo.icon;
  var prioridadeInfo = getPrioridadeInfo(selected.prioridade);

  function handleResponderMensagem(msg) {
    setMensagemCitada(msg);
    // Focar no campo de resposta
    var inputResposta = document.querySelector('input[data-testid="resposta-input"], textarea[data-testid="resposta-input"]');
    if (inputResposta) {
      inputResposta.focus();
    }
  }
  
  function handleEditarMensagem(msg, novoTexto) {
    if (!selected || !msg.id) {
      toast.error('Não é possível editar esta mensagem');
      return;
    }
    axios.put(
      API + '/atendimentos/' + selected.id + '/mensagens/' + msg.id,
      { mensagem: novoTexto },
      { headers: getAuthHeader() }
    ).then(function(res) {
      // Atualizar mensagem localmente
      var novasMensagens = (selected.mensagens || []).map(function(m) {
        if (m.id === msg.id) {
          return { ...m, mensagem: novoTexto, editada: true };
        }
        return m;
      });
      props.onUpdateSelected({ ...selected, mensagens: novasMensagens });
      toast.success('Mensagem editada!');
    }).catch(function(err) {
      toast.error('Erro ao editar mensagem');
    });
  }

  function renderMensagem(msg, index) {
    return <MensagemBubble key={index} msg={msg} onResponder={handleResponderMensagem} onEditar={handleEditarMensagem} />;
  }

  function renderOperador(op) {
    return (
      <Button 
        key={op.id} 
        size="sm" 
        variant="outline" 
        className="hover:bg-blue-50 hover:border-blue-300"
        onClick={function() { 
          onTransferir(op.id); 
          setShowTransferir(false); 
        }}
      >
        <User className="w-4 h-4 mr-2" />
        {op.name}
      </Button>
    );
  }

  var prioridades = ['baixa', 'normal', 'alta', 'urgente'];

  function renderPrioridade(p) {
    var cores = {
      baixa: 'bg-slate-100 text-slate-600 hover:bg-slate-200',
      normal: 'bg-blue-100 text-blue-600 hover:bg-blue-200',
      alta: 'bg-orange-100 text-orange-600 hover:bg-orange-200',
      urgente: 'bg-red-100 text-red-600 hover:bg-red-200'
    };
    return (
      <Button 
        key={p} 
        size="sm" 
        variant="outline"
        className={cores[p] + ' border-0'}
        onClick={function() { 
          onAtualizarPrioridade(selected.id, p); 
          setShowPrioridade(false); 
        }}
      >
        {p === 'urgente' && <AlertTriangle className="w-4 h-4 mr-1" />}
        {p.charAt(0).toUpperCase() + p.slice(1)}
      </Button>
    );
  }

  function renderRespostaRapida(r, index) {
    return (
      <button 
        key={index} 
        className="text-left px-3 py-2 text-sm bg-white border rounded-lg hover:bg-blue-50 hover:border-blue-300 transition-colors"
        onClick={function() { setResposta(r); setShowRespostas(false); }}
      >
        {r.substring(0, 50)}{r.length > 50 ? '...' : ''}
      </button>
    );
  }

  // Iniciais do cliente para avatar
  function getIniciais(nome) {
    if (!nome) return '?';
    var partes = nome.split(' ');
    if (partes.length >= 2) {
      return (partes[0][0] + partes[partes.length - 1][0]).toUpperCase();
    }
    return nome.substring(0, 2).toUpperCase();
  }

  return (
    <div className={'flex-1 flex flex-col h-full min-h-0 bg-white rounded-xl shadow-lg border overflow-hidden ' + (isMobile ? 'fixed inset-0 z-50 rounded-none' : '')} data-testid="chat-panel">
      
      {/* CABEÇALHO FIXO - Não participa do scroll */}
      <div className="flex-shrink-0 bg-white border-b shadow-sm z-20">
        {/* Linha Principal do Header */}
        <div className="px-4 py-3 bg-gradient-to-r from-slate-800 to-slate-900">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              {/* Botão Voltar no Mobile */}
              {isMobile && (
                <Button 
                  size="sm" 
                  variant="ghost" 
                  onClick={onVoltar}
                  className="text-white hover:bg-white/20 p-2"
                  data-testid="voltar-btn"
                >
                  <ArrowLeft className="w-5 h-5" />
                </Button>
              )}
              
              {/* Avatar com Iniciais */}
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-400 to-blue-600 flex items-center justify-center text-white font-bold text-lg shadow-md flex-shrink-0">
                {getIniciais(selected.nome || selected.telefone)}
              </div>
              
              {/* Info do Cliente */}
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="font-bold text-white truncate text-base md:text-lg">
                    {selected.nome || selected.telefone}
                  </h3>
                  <span className={'text-xs px-2 py-0.5 rounded-full font-medium ' + prioridadeInfo.color}>
                    {prioridadeInfo.label}
                  </span>
                </div>
                <div className="flex items-center gap-3 mt-1">
                  <span className="text-slate-300 text-xs flex items-center gap-1">
                    <Phone className="w-3 h-3" />{selected.telefone}
                  </span>
                  <span className="text-slate-300 text-xs">
                    #{selected.protocolo}
                  </span>
                  {selected.canal === 'whatsapp' && (
                    <span className="text-xs bg-green-500 text-white px-2 py-0.5 rounded-full flex items-center gap-1">
                      <MessageSquare className="w-3 h-3" />WhatsApp
                    </span>
                  )}
                </div>
              </div>
            </div>
            
            {/* Status e Tempo */}
            <div className="flex flex-col items-end gap-1 ml-2">
              <div className={'flex items-center gap-1 text-xs px-2 py-1 rounded-full text-white ' + statusInfo.color}>
                <StatusIcon className="w-3 h-3" />
                <span className="hidden sm:inline">{statusInfo.label}</span>
              </div>
              <div className="flex items-center gap-1 text-slate-300 text-xs">
                <Clock className="w-3 h-3" />
                <span>{getTempoAtendimento()}</span>
              </div>
            </div>
          </div>
          
          {/* Operador Responsável */}
          {selected.operador_nome && (
            <div className="mt-2 pt-2 border-t border-white/20">
              <span className="text-xs text-slate-300 flex items-center gap-1">
                <User className="w-3 h-3" />
                Atendente: <span className="text-white font-medium">{selected.operador_nome}</span>
              </span>
            </div>
          )}
        </div>
        
        {/* BARRA DE FERRAMENTAS - AÇÕES RÁPIDAS */}
        <div className="px-2 py-2 bg-slate-50 border-b flex items-center gap-1 overflow-x-auto">
          {/* Dados do Cliente */}
          <Button 
            size="sm" 
            variant={showClienteInfo ? "default" : "ghost"}
            className={'text-xs gap-1 ' + (showClienteInfo ? 'bg-blue-600 text-white' : 'hover:bg-blue-100 text-slate-600')}
            onClick={function() { setShowClienteInfo(!showClienteInfo); setShowBoleto(false); setShowNotas(false); setShowTransferir(false); setShowPrioridade(false); }}
            title="Dados do Cliente"
          >
            <User className="w-4 h-4" />
            <span className="hidden sm:inline">Dados</span>
          </Button>
          
          {/* 2ª Via Boleto */}
          <Button 
            size="sm" 
            variant={showBoleto ? "default" : "ghost"}
            className={'text-xs gap-1 ' + (showBoleto ? 'bg-green-600 text-white' : 'hover:bg-green-100 text-slate-600')}
            onClick={function() { setShowBoleto(!showBoleto); setShowClienteInfo(false); setShowNotas(false); setShowTransferir(false); setShowPrioridade(false); }}
            title="Buscar 2ª Via de Boleto"
          >
            <FileText className="w-4 h-4" />
            <span className="hidden sm:inline">2ª Via</span>
          </Button>
          
          {/* Histórico / Exportar */}
          <Button 
            size="sm" 
            variant="ghost"
            className="text-xs gap-1 hover:bg-purple-100 text-slate-600"
            title="Exportar Conversa"
            onClick={function() { if (selected && onExportar) onExportar(selected.id); }}
            disabled={exportando}
          >
            {exportando ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
            <span className="hidden sm:inline">Exportar</span>
          </Button>
          
          {/* Notas Internas */}
          <Button 
            size="sm" 
            variant={showNotas ? "default" : "ghost"}
            className={'text-xs gap-1 ' + (showNotas ? 'bg-amber-600 text-white' : 'hover:bg-amber-100 text-slate-600')}
            onClick={function() { setShowNotas(!showNotas); setShowBoleto(false); setShowClienteInfo(false); setShowTransferir(false); setShowPrioridade(false); }}
            title="Notas Internas"
          >
            <Tag className="w-4 h-4" />
            <span className="hidden sm:inline">Notas</span>
          </Button>
          
          {/* Prioridade */}
          <Button 
            size="sm" 
            variant={showPrioridade ? "default" : "ghost"}
            className={'text-xs gap-1 ' + (showPrioridade ? 'bg-orange-600 text-white' : 'hover:bg-orange-100 text-slate-600')}
            onClick={function() { setShowPrioridade(!showPrioridade); setShowBoleto(false); setShowNotas(false); setShowClienteInfo(false); setShowTransferir(false); }}
            title="Alterar Prioridade"
          >
            <Star className="w-4 h-4" />
            <span className="hidden sm:inline">Prioridade</span>
          </Button>
          
          {/* Transferir */}
          {selected.status === 'em_atendimento' && (
            <Button 
              size="sm" 
              variant={showTransferir ? "default" : "ghost"}
              className={'text-xs gap-1 ' + (showTransferir ? 'bg-indigo-600 text-white' : 'hover:bg-indigo-100 text-slate-600')}
              onClick={function() { setShowTransferir(!showTransferir); setShowBoleto(false); setShowNotas(false); setShowClienteInfo(false); setShowPrioridade(false); }}
              title="Transferir Atendimento"
            >
              <ArrowRightLeft className="w-4 h-4" />
              <span className="hidden sm:inline">Transferir</span>
            </Button>
          )}
          
          {/* Espaçador */}
          <div className="flex-1" />
          
          {/* Botões Principais */}
          {selected.status !== 'em_atendimento' && selected.status !== 'finalizado' && (
            <Button 
              size="sm" 
              onClick={function() { assumir(selected.id); }} 
              className="bg-blue-600 hover:bg-blue-700 text-white text-xs gap-1 shadow-md" 
              data-testid="assumir-btn"
            >
              <UserPlus className="w-4 h-4" />
              <span>Assumir</span>
            </Button>
          )}
          {selected.status === 'em_atendimento' && (
            <Button 
              size="sm" 
              onClick={handleFinalizarClick}
              className="bg-green-600 hover:bg-green-700 text-white text-xs gap-1 shadow-md" 
              data-testid="finalizar-btn"
            >
              <CheckCircle className="w-4 h-4" />
              <span>Finalizar</span>
            </Button>
          )}
          
          {!isMobile && (
            <Button size="sm" variant="ghost" onClick={onClose} className="ml-1" data-testid="close-chat-btn">
              <X className="w-4 h-4" />
            </Button>
          )}
        </div>
        
        {/* PAINÉIS EXPANDÍVEIS */}
        
        {/* Painel: Dados do Cliente */}
        {showClienteInfo && (
          <div className="px-4 py-3 bg-blue-50 border-b animate-in slide-in-from-top-2">
            <div className="flex items-center justify-between mb-2">
              <h4 className="font-medium text-blue-800 flex items-center gap-2">
                <User className="w-4 h-4" />Informações do Cliente
              </h4>
              {!editandoContato ? (
                <Button 
                  size="sm" 
                  variant="outline" 
                  className="text-blue-600 border-blue-300 hover:bg-blue-100"
                  onClick={iniciarEdicaoContato}
                  data-testid="editar-contato-btn"
                >
                  <Edit2 className="w-3 h-3 mr-1" />
                  Editar
                </Button>
              ) : (
                <div className="flex gap-2">
                  <Button 
                    size="sm" 
                    variant="outline"
                    className="text-slate-600"
                    onClick={cancelarEdicaoContato}
                  >
                    Cancelar
                  </Button>
                  <Button 
                    size="sm" 
                    className="bg-blue-600 hover:bg-blue-700"
                    onClick={salvarContato}
                    disabled={salvandoContato}
                    data-testid="salvar-contato-btn"
                  >
                    {salvandoContato ? <Loader2 className="w-3 h-3 mr-1 animate-spin" /> : <Save className="w-3 h-3 mr-1" />}
                    Salvar
                  </Button>
                </div>
              )}
            </div>
            
            {!editandoContato ? (
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3 text-sm">
                <div>
                  <span className="text-slate-500">Nome:</span>
                  <div className="flex items-center gap-2">
                    <p className="font-medium text-slate-800">{selected.nome || 'Não identificado'}</p>
                    {!selected.nome && (
                      <Button 
                        variant="ghost" 
                        size="sm" 
                        className="h-6 px-2 text-xs text-blue-600 hover:text-blue-800 hover:bg-blue-50"
                        onClick={async function() {
                          try {
                            toast.loading('Buscando cliente no IXC...');
                            var resp = await axios.post(API + '/atendimentos/' + selected.id + '/identificar-cliente', {}, { headers: getAuthHeader() });
                            toast.dismiss();
                            if (resp.data.encontrado) {
                              toast.success('Cliente identificado: ' + resp.data.cliente.nome);
                              // Atualizar o atendimento selecionado com os novos dados
                              setSelected(function(prev) {
                                return { ...prev, nome: resp.data.cliente.nome, cliente_ixc_id: resp.data.cliente.id, cpf_cnpj: resp.data.cliente.cpf_cnpj };
                              });
                              // Atualizar na lista
                              setAtendimentos(function(prev) {
                                return prev.map(function(a) {
                                  if (a.id === selected.id) {
                                    return { ...a, nome: resp.data.cliente.nome, cliente_ixc_id: resp.data.cliente.id };
                                  }
                                  return a;
                                });
                              });
                            } else {
                              toast.info('Nenhum cliente encontrado no IXC com este telefone');
                            }
                          } catch (err) {
                            toast.dismiss();
                            toast.error('Erro ao buscar cliente: ' + (err.response?.data?.detail || err.message));
                          }
                        }}
                        data-testid="identificar-cliente-btn"
                      >
                        <Search className="w-3 h-3 mr-1" />
                        Buscar no IXC
                      </Button>
                    )}
                  </div>
                </div>
                <div>
                  <span className="text-slate-500">Telefone:</span>
                  <p className="font-medium text-slate-800">{selected.telefone}</p>
                </div>
                <div>
                  <span className="text-slate-500">CPF/CNPJ:</span>
                  <p className="font-medium text-slate-800">{selected.cpf_cnpj || '-'}</p>
                </div>
                <div>
                  <span className="text-slate-500">E-mail:</span>
                  <p className="font-medium text-slate-800">{selected.email || '-'}</p>
                </div>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div>
                  <label className="text-xs text-slate-500 mb-1 block">Nome *</label>
                  <Input 
                    value={dadosContato.nome}
                    onChange={function(e) { setDadosContato({...dadosContato, nome: e.target.value}); }}
                    placeholder="Nome do cliente"
                    className="bg-white"
                    data-testid="contato-nome-input"
                  />
                </div>
                <div>
                  <label className="text-xs text-slate-500 mb-1 block">Telefone</label>
                  <Input 
                    value={dadosContato.telefone}
                    onChange={function(e) { setDadosContato({...dadosContato, telefone: e.target.value}); }}
                    placeholder="5519999999999"
                    className="bg-white"
                    data-testid="contato-telefone-input"
                  />
                </div>
                <div>
                  <label className="text-xs text-slate-500 mb-1 block">CPF/CNPJ</label>
                  <Input 
                    value={dadosContato.cpf_cnpj}
                    onChange={function(e) { setDadosContato({...dadosContato, cpf_cnpj: e.target.value}); }}
                    placeholder="CPF ou CNPJ"
                    className="bg-white"
                    data-testid="contato-cpf-input"
                  />
                </div>
                <div>
                  <label className="text-xs text-slate-500 mb-1 block">E-mail</label>
                  <Input 
                    value={dadosContato.email}
                    onChange={function(e) { setDadosContato({...dadosContato, email: e.target.value}); }}
                    placeholder="email@exemplo.com"
                    className="bg-white"
                    data-testid="contato-email-input"
                  />
                </div>
                <div>
                  <label className="text-xs text-slate-500 mb-1 block">Endereço</label>
                  <Input 
                    value={dadosContato.endereco}
                    onChange={function(e) { setDadosContato({...dadosContato, endereco: e.target.value}); }}
                    placeholder="Endereço completo"
                    className="bg-white"
                    data-testid="contato-endereco-input"
                  />
                </div>
              </div>
            )}
          </div>
        )}
        
        {/* Painel: Buscar Boleto */}
        {showBoleto && (
          <div className="px-4 py-3 bg-green-50 border-b animate-in slide-in-from-top-2">
            <h4 className="font-medium text-green-800 mb-2 flex items-center gap-2">
              <FileText className="w-4 h-4" />Buscar 2ª Via de Boleto
            </h4>
            <div className="flex gap-2 mb-2">
              <Input 
                placeholder="Digite o CPF, CNPJ ou Nome do cliente" 
                value={cpfBoleto} 
                onChange={function(e) { setCpfBoleto(e.target.value); }}
                onKeyDown={function(e) { if (e.key === 'Enter') handleBuscarClientes(); }}
                className="flex-1 bg-white"
                data-testid="cpf-boleto-input"
              />
              <Button 
                onClick={handleBuscarClientes} 
                className="bg-green-600 hover:bg-green-700" 
                disabled={buscandoBoleto}
                data-testid="buscar-boleto-btn"
              >
                {buscandoBoleto ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Search className="w-4 h-4 mr-2" />}
                Buscar
              </Button>
            </div>
            <p className="text-xs text-green-600 mb-2">Você pode buscar por CPF, CNPJ ou parte do nome do cliente</p>
            
            {/* Lista de Clientes Encontrados para Confirmação */}
            {clientesBoleto.length > 0 && (
              <div className="mt-3 bg-white rounded-lg border border-green-200 overflow-hidden">
                <div className="bg-green-100 px-3 py-2 text-sm font-medium text-green-800">
                  ⚠️ Selecione o cliente correto antes de enviar:
                </div>
                <div className="max-h-48 overflow-y-auto">
                  {clientesBoleto.map(function(cliente, index) {
                    return (
                      <div 
                        key={index} 
                        className="flex items-center justify-between px-3 py-2 border-b hover:bg-green-50 cursor-pointer"
                        onClick={function() { setClienteSelecionadoBoleto(cliente); }}
                      >
                        <div className="flex-1">
                          <p className="font-medium text-slate-800">{cliente.nome}</p>
                          <p className="text-xs text-slate-500">
                            CPF/CNPJ: {cliente.cpf_cnpj || 'N/A'} | Plano: {cliente.plano || 'N/A'} | {cliente.tipo_plano || ''}
                          </p>
                        </div>
                        <Button 
                          size="sm" 
                          className="bg-green-600 hover:bg-green-700 text-white ml-2"
                          onClick={function(e) { 
                            e.stopPropagation(); 
                            confirmarEnvioBoleto(cliente); 
                          }}
                        >
                          <Send className="w-3 h-3 mr-1" />
                          Enviar Boleto
                        </Button>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}
        
        {/* Painel: Notas Internas */}
        {showNotas && (
          <div className="px-4 py-3 bg-amber-50 border-b animate-in slide-in-from-top-2">
            <h4 className="font-medium text-amber-800 mb-2 flex items-center gap-2">
              <Tag className="w-4 h-4" />Notas Internas (não visível ao cliente)
            </h4>
            <div className="flex gap-2">
              <Input 
                placeholder="Adicionar nota interna..." 
                value={notaInterna} 
                onChange={function(e) { setNotaInterna(e.target.value); }}
                className="flex-1 bg-white"
              />
              <Button 
                className="bg-amber-600 hover:bg-amber-700"
                onClick={function() { 
                  if (notaInterna.trim()) {
                    toast.success('Nota adicionada!');
                    setNotaInterna('');
                  }
                }}
              >
                Salvar
              </Button>
            </div>
          </div>
        )}
        
        {/* Painel: Prioridade */}
        {showPrioridade && (
          <div className="px-4 py-3 bg-orange-50 border-b animate-in slide-in-from-top-2">
            <h4 className="font-medium text-orange-800 mb-2 flex items-center gap-2">
              <Star className="w-4 h-4" />Alterar Prioridade do Atendimento
            </h4>
            <div className="flex flex-wrap gap-2">
              {prioridades.map(renderPrioridade)}
            </div>
          </div>
        )}
        
        {/* Painel: Transferir */}
        {showTransferir && (
          <div className="px-4 py-3 bg-indigo-50 border-b animate-in slide-in-from-top-2">
            <h4 className="font-medium text-indigo-800 mb-2 flex items-center gap-2">
              <ArrowRightLeft className="w-4 h-4" />Transferir para outro Atendente
            </h4>
            <div className="flex flex-wrap gap-2">
              {operadores.length > 0 ? operadores.map(renderOperador) : (
                <p className="text-sm text-slate-500">Nenhum operador disponível no momento</p>
              )}
            </div>
          </div>
        )}
      </div>

      {/* ÁREA DE MENSAGENS - Com scroll */}
      <div className="flex-1 min-h-0 overflow-y-auto p-4 space-y-3 bg-gradient-to-b from-slate-100 to-slate-50">
        {mensagens.length === 0 ? (
          <div className="flex items-center justify-center h-full">
            <div className="text-center text-slate-400">
              <Inbox className="w-12 h-12 mx-auto mb-3 opacity-50" />
              <p>Nenhuma mensagem ainda</p>
            </div>
          </div>
        ) : (
          mensagens.map(renderMensagem)
        )}
        <div ref={messagesEndRef} />
      </div>

      {/* ÁREA DE DIGITAÇÃO - Fixa no rodapé */}
      {selected.status !== 'finalizado' ? (
        <div className="flex-shrink-0 border-t bg-white p-3">
          {/* Respostas Rápidas */}
          {showRespostas && (
            <div className="mb-3 p-3 bg-slate-50 rounded-lg border animate-in slide-in-from-bottom-2">
              <div className="flex items-center justify-between mb-2">
                <h4 className="text-sm font-medium text-slate-700 flex items-center gap-2">
                  <Zap className="w-4 h-4 text-amber-500" />
                  Respostas Rápidas
                </h4>
                <Button size="sm" variant="ghost" onClick={function() { setShowRespostas(false); }}>
                  <X className="w-4 h-4" />
                </Button>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-2 max-h-40 overflow-y-auto">
                {respostasRapidas.map(renderRespostaRapida)}
              </div>
            </div>
          )}
          
          <form onSubmit={handleEnviar} className="flex gap-2 items-end pr-16">
            <Button 
              type="button" 
              variant="outline" 
              size="icon"
              className={'hover:bg-amber-100 hover:border-amber-300 ' + (showRespostas ? 'bg-amber-100 border-amber-300' : '')}
              onClick={function() { setShowRespostas(!showRespostas); }}
              title="Respostas Rápidas"
            >
              <Zap className="w-5 h-5 text-amber-500" />
            </Button>
            
            {/* Área de gravação de áudio */}
            {gravandoAudio ? (
              <div className="flex-1 flex items-center gap-3 bg-red-50 border border-red-200 rounded-lg px-4 py-3">
                <div className="flex items-center gap-2">
                  <span className="w-3 h-3 bg-red-500 rounded-full animate-pulse"></span>
                  <span className="text-red-600 font-medium">{formatarTempoGravacao(tempoGravacao)}</span>
                </div>
                <span className="text-sm text-red-600">Gravando áudio...</span>
                <div className="flex-1"></div>
                <Button 
                  type="button"
                  variant="ghost"
                  size="sm"
                  className="text-slate-500 hover:text-slate-700"
                  onClick={cancelarGravacao}
                  title="Cancelar gravação"
                >
                  <X className="w-5 h-5" />
                </Button>
                <Button 
                  type="button"
                  size="icon"
                  className="bg-red-600 hover:bg-red-700 h-12 w-12 rounded-full shadow-lg"
                  onClick={pararGravacao}
                  title="Parar e enviar"
                >
                  <Square className="w-5 h-5" />
                </Button>
              </div>
            ) : enviandoAudio ? (
              <div className="flex-1 flex items-center justify-center gap-3 bg-blue-50 border border-blue-200 rounded-lg px-4 py-3">
                <Loader className="w-5 h-5 text-blue-600 animate-spin" />
                <span className="text-blue-600">Enviando áudio...</span>
              </div>
            ) : (
              <>
                {/* Área de citação - quando está respondendo uma mensagem */}
                {mensagemCitada && (
                  <div className="absolute bottom-full left-0 right-0 mb-2 mx-4">
                    <div className="bg-slate-100 rounded-lg p-3 border-l-4 border-blue-500 flex items-start justify-between">
                      <div className="flex-1 min-w-0">
                        <p className="text-xs font-medium text-blue-600 mb-1">
                          Respondendo a {mensagemCitada.nome_remetente}
                        </p>
                        <p className="text-sm text-slate-600 truncate">
                          {mensagemCitada.mensagem && mensagemCitada.mensagem.substring(0, 80)}{mensagemCitada.mensagem && mensagemCitada.mensagem.length > 80 ? '...' : ''}
                        </p>
                      </div>
                      <button 
                        onClick={function() { setMensagemCitada(null); }}
                        className="ml-2 p-1 hover:bg-slate-200 rounded"
                      >
                        <X className="w-4 h-4 text-slate-500" />
                      </button>
                    </div>
                  </div>
                )}
                <div className="flex-1 relative">
                  <Input 
                    className="pr-12 py-6 text-base bg-slate-50 border-slate-200 focus:bg-white" 
                    placeholder="Digite sua mensagem..." 
                    value={resposta} 
                    onChange={function(e) { setResposta(e.target.value); }}
                    data-testid="resposta-input"
                  />
                </div>
                
                {/* Input hidden para arquivo */}
                <input 
                  type="file" 
                  ref={fileInputRef}
                  className="hidden"
                  accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt"
                  onChange={handleFileSelect}
                />
                
                {/* Botão de anexar arquivo */}
                {enviandoArquivo ? (
                  <Button 
                    type="button"
                    size="icon"
                    variant="outline"
                    className="h-12 w-12 rounded-full"
                    disabled
                  >
                    <Loader className="w-5 h-5 animate-spin text-slate-400" />
                  </Button>
                ) : (
                  <Button 
                    type="button"
                    size="icon"
                    variant="outline"
                    className="h-12 w-12 rounded-full border-slate-300 hover:bg-slate-50 hover:border-slate-400"
                    onClick={function() { fileInputRef.current && fileInputRef.current.click(); }}
                    title="Anexar arquivo ou imagem"
                    data-testid="anexar-arquivo-btn"
                  >
                    <Paperclip className="w-5 h-5 text-slate-600" />
                  </Button>
                )}
                
                {/* Botão de áudio - aparece quando não há texto */}
                {!resposta.trim() ? (
                  <Button 
                    type="button"
                    size="icon"
                    variant="outline"
                    className="h-12 w-12 rounded-full border-green-300 hover:bg-green-50 hover:border-green-400"
                    onClick={iniciarGravacao}
                    title="Gravar áudio"
                    data-testid="gravar-audio-btn"
                  >
                    <Mic className="w-5 h-5 text-green-600" />
                  </Button>
                ) : null}
                
                <Button 
                  type="submit" 
                  size="icon"
                  className="bg-blue-600 hover:bg-blue-700 h-12 w-12 rounded-full shadow-lg" 
                  data-testid="enviar-btn"
                >
                  <Send className="w-5 h-5" />
                </Button>
              </>
            )}
          </form>
        </div>
      ) : (
        <div className="border-t bg-green-50 p-4 text-center">
          <div className="flex items-center justify-center gap-2 text-green-700">
            <CheckCircle className="w-5 h-5" />
            <span className="font-medium">Atendimento Finalizado</span>
          </div>
          <p className="text-sm text-green-600 mt-1">Este atendimento foi encerrado</p>
        </div>
      )}
    </div>
  );
}

// Modal Criar Atendente
function ModalCriarAtendente(props) {
  var isOpen = props.isOpen;
  var onClose = props.onClose;
  var onSave = props.onSave;

  var nomeState = useState('');
  var nome = nomeState[0];
  var setNome = nomeState[1];
  var usernameState = useState('');
  var username = usernameState[0];
  var setUsername = usernameState[1];
  var passwordState = useState('');
  var password = passwordState[0];
  var setPassword = passwordState[1];
  var savingState = useState(false);
  var saving = savingState[0];
  var setSaving = savingState[1];

  function handleSave() {
    if (!nome || !username || !password) {
      toast.error('Preencha todos os campos');
      return;
    }
    setSaving(true);
    onSave({ nome: nome, username: username, password: password })
      .then(function() {
        setNome('');
        setUsername('');
        setPassword('');
        onClose();
      })
      .finally(function() { setSaving(false); });
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-xl p-6 w-full max-w-md shadow-xl" onClick={function(e) { e.stopPropagation(); }}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Criar Novo Atendente</h3>
          <Button variant="ghost" size="sm" onClick={onClose}>
            <X className="w-4 h-4" />
          </Button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-sm font-medium text-slate-700">Nome</label>
            <Input 
              placeholder="Nome do atendente" 
              value={nome}
              onChange={function(e) { setNome(e.target.value); }}
            />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">Email/Usuário</label>
            <Input 
              placeholder="email@exemplo.com" 
              value={username}
              onChange={function(e) { setUsername(e.target.value); }}
            />
          </div>
          <div>
            <label className="text-sm font-medium text-slate-700">Senha</label>
            <Input 
              type="password" 
              placeholder="Senha" 
              value={password}
              onChange={function(e) { setPassword(e.target.value); }}
            />
          </div>
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={onClose} className="flex-1">Cancelar</Button>
            <Button onClick={handleSave} className="flex-1 bg-blue-600" disabled={saving}>
              {saving ? 'Salvando...' : 'Criar Atendente'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Modal Buscar Conversa
function ModalBuscarConversa(props) {
  var isOpen = props.isOpen;
  var onClose = props.onClose;
  var onSearch = props.onSearch;
  var onVisualizar = props.onVisualizar;
  var onExportar = props.onExportar;

  var protocoloState = useState('');
  var protocolo = protocoloState[0];
  var setProtocolo = protocoloState[1];
  var telefoneState = useState('');
  var telefone = telefoneState[0];
  var setTelefone = telefoneState[1];
  var searchingState = useState(false);
  var searching = searchingState[0];
  var setSearching = searchingState[1];
  var resultadosState = useState([]);
  var resultados = resultadosState[0];
  var setResultados = resultadosState[1];

  function handleSearch() {
    if (!protocolo && !telefone) {
      toast.error('Informe o protocolo ou telefone');
      return;
    }
    setSearching(true);
    onSearch({ protocolo: protocolo, telefone: telefone })
      .then(function(data) { setResultados(data); })
      .finally(function() { setSearching(false); });
  }

  if (!isOpen) return null;

  function renderResultado(r) {
    return (
      <div key={r.id} className="p-3 border rounded-lg hover:bg-slate-50">
        <div className="flex justify-between items-start gap-2">
          <div className="flex-1 min-w-0">
            <p className="font-medium truncate">{r.nome || r.telefone}</p>
            <p className="text-xs text-slate-500">#{r.protocolo}</p>
            <p className="text-xs text-slate-400">{r.categoria || 'Sem categoria'}</p>
          </div>
          <div className="flex flex-col items-end gap-1">
            <span className={'text-xs px-2 py-1 rounded-full ' + (r.status === 'finalizado' ? 'bg-green-100 text-green-700' : 'bg-orange-100 text-orange-700')}>
              {r.status}
            </span>
            <div className="flex gap-1 mt-1">
              <Button 
                size="sm" 
                variant="outline" 
                className="h-7 px-2 text-xs"
                onClick={function() { if (onVisualizar) { onVisualizar(r); onClose(); } }}
              >
                <Eye className="w-3 h-3 mr-1" />
                Ver
              </Button>
              <Button 
                size="sm" 
                variant="outline" 
                className="h-7 px-2 text-xs text-blue-600 border-blue-300 hover:bg-blue-50"
                onClick={function() { if (onExportar) onExportar(r.id); }}
              >
                <Download className="w-3 h-3 mr-1" />
                Exportar
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-xl p-6 w-full max-w-lg shadow-xl" onClick={function(e) { e.stopPropagation(); }}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold">Buscar Conversa</h3>
          <Button variant="ghost" size="sm" onClick={onClose}>
            <X className="w-4 h-4" />
          </Button>
        </div>
        <div className="space-y-4">
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="text-sm font-medium text-slate-700">Protocolo</label>
              <Input 
                placeholder="Ex: 2024010112345678" 
                value={protocolo}
                onChange={function(e) { setProtocolo(e.target.value); }}
              />
            </div>
            <div>
              <label className="text-sm font-medium text-slate-700">Telefone</label>
              <Input 
                placeholder="Ex: 11999999999" 
                value={telefone}
                onChange={function(e) { setTelefone(e.target.value); }}
              />
            </div>
          </div>
          <Button onClick={handleSearch} className="w-full bg-blue-600" disabled={searching}>
            <Search className="w-4 h-4 mr-2" />
            {searching ? 'Buscando...' : 'Buscar'}
          </Button>
          
          {resultados.length > 0 && (
            <div className="mt-4 space-y-2 max-h-80 overflow-y-auto">
              <p className="text-sm font-medium text-slate-600">Resultados ({resultados.length}):</p>
              {resultados.map(renderResultado)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

// Modal Iniciar Conversa (Mensagem Ativa)

function ModalContatos(props) {
  var isOpen = props.isOpen;
  var onClose = props.onClose;

  var buscaState = useState('');
  var busca = buscaState[0];
  var setBusca = buscaState[1];
  var contatosState = useState([]);
  var contatos = contatosState[0];
  var setContatos = contatosState[1];
  var loadingState = useState(false);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var editandoState = useState(null);
  var editando = editandoState[0];
  var setEditando = editandoState[1];
  var formState = useState({ nome: '', telefone: '', cpf_cnpj: '', email: '' });
  var form = formState[0];
  var setForm = formState[1];
  var salvandoState = useState(false);
  var salvando = salvandoState[0];
  var setSalvando = salvandoState[1];

  function buscarContatos(termo) {
    if (!termo || termo.length < 2) { setContatos([]); return; }
    setLoading(true);
    axios.get(API + '/contatos/buscar?termo=' + encodeURIComponent(termo) + '&limit=20', { headers: getAuthHeader() })
      .then(function(res) {
        setContatos(res.data.contatos || []);
        setLoading(false);
      })
      .catch(function() { setContatos([]); setLoading(false); });
  }

  function iniciarEdicao(contato) {
    setEditando(contato.id || contato.telefone);
    setForm({
      nome: contato.nome || '',
      telefone: contato.telefone || '',
      cpf_cnpj: contato.cpf_cnpj || '',
      email: contato.email || ''
    });
  }

  function cancelarEdicao() {
    setEditando(null);
    setForm({ nome: '', telefone: '', cpf_cnpj: '', email: '' });
  }

  function salvarContato(contato) {
    if (!form.nome.trim()) { toast.error('Nome é obrigatório'); return; }
    setSalvando(true);
    axios.put(
      API + '/contatos/' + encodeURIComponent(contato.telefone),
      form,
      { headers: getAuthHeader() }
    ).then(function() {
      toast.success('Contato atualizado!');
      setEditando(null);
      // Atualizar na lista local
      setContatos(function(prev) {
        return prev.map(function(c) {
          if ((c.id || c.telefone) === (contato.id || contato.telefone)) {
            return { ...c, ...form };
          }
          return c;
        });
      });
      setSalvando(false);
    }).catch(function(err) {
      toast.error(err.response?.data?.detail || 'Erro ao salvar');
      setSalvando(false);
    });
  }

  function criarNovoContato() {
    if (!form.nome.trim() || !form.telefone.trim()) { toast.error('Nome e telefone são obrigatórios'); return; }
    setSalvando(true);
    axios.post(API + '/contatos', form, { headers: getAuthHeader() })
      .then(function(res) {
        toast.success('Contato criado!');
        setContatos(function(prev) { return [res.data, ...prev]; });
        setEditando(null);
        setForm({ nome: '', telefone: '', cpf_cnpj: '', email: '' });
        setSalvando(false);
      })
      .catch(function(err) {
        toast.error(err.response?.data?.detail || 'Erro ao criar contato');
        setSalvando(false);
      });
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="modal-contatos">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col">
        {/* Header */}
        <div className="p-4 border-b flex items-center justify-between bg-slate-50 rounded-t-xl">
          <div className="flex items-center gap-2">
            <Users className="w-5 h-5 text-blue-600" />
            <h2 className="font-bold text-lg text-slate-800">Contatos</h2>
          </div>
          <Button variant="ghost" size="sm" onClick={onClose} data-testid="fechar-contatos-btn">
            <X className="w-5 h-5" />
          </Button>
        </div>

        {/* Search */}
        <div className="p-4 border-b">
          <div className="flex gap-2">
            <div className="relative flex-1">
              <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
              <Input
                className="pl-9"
                placeholder="Buscar por nome, telefone ou CPF..."
                value={busca}
                onChange={function(e) { setBusca(e.target.value); buscarContatos(e.target.value); }}
                data-testid="contatos-busca-input"
              />
            </div>
            <Button 
              size="sm" 
              variant="outline"
              onClick={function() { 
                setEditando('novo');
                setForm({ nome: '', telefone: '', cpf_cnpj: '', email: '' });
              }}
              data-testid="novo-contato-btn"
            >
              <UserPlus className="w-4 h-4 mr-1" /> Novo
            </Button>
          </div>
        </div>

        {/* Formulário Novo Contato */}
        {editando === 'novo' && (
          <div className="p-4 border-b bg-blue-50">
            <h4 className="font-medium text-blue-800 mb-2 text-sm">Novo Contato</h4>
            <div className="grid grid-cols-2 gap-2 mb-2">
              <Input placeholder="Nome *" value={form.nome} onChange={function(e) { setForm({...form, nome: e.target.value}); }} data-testid="novo-contato-nome" />
              <Input placeholder="Telefone *" value={form.telefone} onChange={function(e) { setForm({...form, telefone: e.target.value}); }} data-testid="novo-contato-telefone" />
              <Input placeholder="CPF/CNPJ" value={form.cpf_cnpj} onChange={function(e) { setForm({...form, cpf_cnpj: e.target.value}); }} />
              <Input placeholder="E-mail" value={form.email} onChange={function(e) { setForm({...form, email: e.target.value}); }} />
            </div>
            <div className="flex gap-2 justify-end">
              <Button size="sm" variant="ghost" onClick={cancelarEdicao}>Cancelar</Button>
              <Button size="sm" onClick={criarNovoContato} disabled={salvando} data-testid="salvar-novo-contato-btn">
                {salvando ? <Loader2 className="w-3 h-3 animate-spin mr-1" /> : <Save className="w-3 h-3 mr-1" />}
                Salvar
              </Button>
            </div>
          </div>
        )}

        {/* Lista de Contatos */}
        <div className="flex-1 overflow-auto p-2">
          {loading && (
            <div className="flex items-center justify-center py-8 text-slate-400">
              <Loader2 className="w-5 h-5 animate-spin mr-2" />Buscando...
            </div>
          )}
          
          {!loading && contatos.length === 0 && busca.length >= 2 && (
            <div className="text-center py-8 text-slate-400">
              <Users className="w-8 h-8 mx-auto mb-2 opacity-50" />
              <p className="text-sm">Nenhum contato encontrado</p>
            </div>
          )}

          {!loading && contatos.length === 0 && busca.length < 2 && (
            <div className="text-center py-8 text-slate-400">
              <Search className="w-8 h-8 mx-auto mb-2 opacity-50" />
              <p className="text-sm">Digite para buscar contatos</p>
            </div>
          )}

          {contatos.map(function(contato) {
            var isEditando = editando === (contato.id || contato.telefone);
            return (
              <div key={contato.id || contato.telefone} className="border rounded-lg p-3 mb-2 hover:bg-slate-50 transition-colors" data-testid="contato-item">
                {isEditando ? (
                  <div>
                    <div className="grid grid-cols-2 gap-2 mb-2">
                      <Input placeholder="Nome *" value={form.nome} onChange={function(e) { setForm({...form, nome: e.target.value}); }} data-testid="editar-contato-nome" />
                      <Input placeholder="Telefone" value={form.telefone} onChange={function(e) { setForm({...form, telefone: e.target.value}); }} data-testid="editar-contato-telefone" />
                      <Input placeholder="CPF/CNPJ" value={form.cpf_cnpj} onChange={function(e) { setForm({...form, cpf_cnpj: e.target.value}); }} />
                      <Input placeholder="E-mail" value={form.email} onChange={function(e) { setForm({...form, email: e.target.value}); }} />
                    </div>
                    <div className="flex gap-2 justify-end">
                      <Button size="sm" variant="ghost" onClick={cancelarEdicao}>Cancelar</Button>
                      <Button size="sm" onClick={function() { salvarContato(contato); }} disabled={salvando} data-testid="salvar-editar-contato-btn">
                        {salvando ? <Loader2 className="w-3 h-3 animate-spin mr-1" /> : <Save className="w-3 h-3 mr-1" />}
                        Salvar
                      </Button>
                    </div>
                  </div>
                ) : (
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="font-medium text-slate-800">{contato.nome || 'Sem nome'}</p>
                      <div className="flex items-center gap-3 text-xs text-slate-500">
                        <span className="flex items-center gap-1"><Phone className="w-3 h-3" />{contato.telefone}</span>
                        {contato.cpf_cnpj && <span>{contato.cpf_cnpj}</span>}
                        {contato.email && <span>{contato.email}</span>}
                      </div>
                    </div>
                    <Button size="sm" variant="ghost" onClick={function() { iniciarEdicao(contato); }} data-testid="editar-contato-btn">
                      <Edit2 className="w-4 h-4 text-blue-600" />
                    </Button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}


function ModalIniciarConversa(props) {
  var isOpen = props.isOpen;
  var onClose = props.onClose;
  var onIniciar = props.onIniciar;

  var telefoneState = useState('');
  var telefone = telefoneState[0];
  var setTelefone = telefoneState[1];
  var nomeClienteState = useState('');
  var nomeCliente = nomeClienteState[0];
  var setNomeCliente = nomeClienteState[1];
  var mensagemPadraoState = useState('Olá, Bem-vindo(a) à Home On Telecomunicações');
  var mensagemPadrao = mensagemPadraoState[0];
  var setMensagemPadrao = mensagemPadraoState[1];
  var mensagemState = useState('');
  var mensagem = mensagemState[0];
  var setMensagem = mensagemState[1];
  var enviandoState = useState(false);
  var enviando = enviandoState[0];
  var setEnviando = enviandoState[1];
  var clientesBuscaState = useState([]);
  var clientesBusca = clientesBuscaState[0];
  var setClientesBusca = clientesBuscaState[1];
  var showClientesState = useState(false);
  var showClientes = showClientesState[0];
  var setShowClientes = showClientesState[1];
  var buscandoState = useState(false);
  var buscando = buscandoState[0];
  var setBuscando = buscandoState[1];
  var fonteState = useState('ixc');
  var fonte = fonteState[0];
  var setFonte = fonteState[1];
  var termoBuscaState = useState('');
  var termoBusca = termoBuscaState[0];
  var setTermoBusca = termoBuscaState[1];
  
  // Canais Z-API
  var canaisState = useState([]);
  var canais = canaisState[0];
  var setCanais = canaisState[1];
  var canalSelecionadoState = useState('');
  var canalSelecionado = canalSelecionadoState[0];
  var setCanalSelecionado = canalSelecionadoState[1];
  
  // Carregar canais e saudação ao abrir modal
  useEffect(function() {
    if (isOpen) {
      // Carregar canais
      axios.get(API + '/whatsapp/canais', { headers: getAuthHeader() })
        .then(function(res) {
          var lista = res.data.canais || [];
          setCanais(lista);
          // Selecionar canal principal por padrão
          var principal = lista.find(function(c) { return c.principal; });
          if (principal) {
            setCanalSelecionado(principal.id);
          } else if (lista.length > 0) {
            setCanalSelecionado(lista[0].id);
          }
        })
        .catch(function() {});
      
      // Carregar saudação configurada
      axios.get(API + '/config/mensagens', { headers: getAuthHeader() })
        .then(function(res) {
          var msgs = res.data.mensagens || {};
          var saudacao = msgs.saudacao_base || msgs.boas_vindas || 'Olá, Bem-vindo(a) à Home On Telecomunicações';
          setMensagemPadrao(saudacao);
          setMensagem(saudacao);
        })
        .catch(function() {
          setMensagem(mensagemPadrao);
        });
    }
  }, [isOpen]);

  function buscarClientes(termo) {
    setTermoBusca(termo);
    if (termo.length < 2) {
      setClientesBusca([]);
      setShowClientes(false);
      return;
    }
    
    setBuscando(true);
    
    // Buscar no IXC ou local dependendo da fonte selecionada
    var endpoint = fonte === 'ixc' 
      ? API + '/ixc/clientes/buscar?termo=' + encodeURIComponent(termo) + '&limit=10'
      : API + '/clientes?search=' + encodeURIComponent(termo) + '&limit=10';
    
    axios.get(endpoint, { headers: getAuthHeader() })
      .then(function(res) {
        var lista = res.data.clientes || res.data || [];
        setClientesBusca(lista);
        setShowClientes(lista.length > 0);
        setBuscando(false);
      })
      .catch(function() { 
        setClientesBusca([]);
        setBuscando(false);
      });
  }

  function selecionarCliente(cliente) {
    setNomeCliente(cliente.nome || cliente.razao || '');
    // Priorizar whatsapp, depois telefone_celular, depois telefone
    var tel = cliente.whatsapp || cliente.telefone_celular || cliente.telefone_limpo || cliente.telefone || '';
    setTelefone(tel.replace(/\D/g, ''));
    setShowClientes(false);
    setClientesBusca([]);
    setTermoBusca('');
  }

  function handleIniciar() {
    if (!telefone || !mensagem) {
      toast.error('Preencha o telefone e a mensagem');
      return;
    }
    if (!canalSelecionado) {
      toast.error('Selecione um canal para enviar');
      return;
    }
    setEnviando(true);
    onIniciar({ telefone: telefone, mensagem: mensagem, nome_cliente: nomeCliente, canal_id: canalSelecionado })
      .then(function() {
        setTelefone('');
        setNomeCliente('');
        setMensagem(mensagemPadrao);  // Usar a saudação configurada
        onClose();
      })
      .finally(function() { setEnviando(false); });
  }

  if (!isOpen) return null;

  function renderClienteBusca(c) {
    var temWhatsapp = c.whatsapp || c.telefone_celular || c.telefone_limpo || c.telefone;
    return (
      <div 
        key={c.id} 
        className={'p-3 hover:bg-slate-100 cursor-pointer rounded border-b last:border-b-0 ' + (!temWhatsapp ? 'opacity-50' : '')}
        onClick={function() { if (temWhatsapp) selecionarCliente(c); }}
      >
        <div className="flex items-center justify-between">
          <div>
            <p className="font-medium text-sm">{c.nome || c.razao}</p>
            <p className="text-xs text-slate-500">{c.cpf_cnpj}</p>
          </div>
          <div className="text-right">
            {c.whatsapp ? (
              <p className="text-xs text-green-600 font-medium">📱 {c.whatsapp}</p>
            ) : c.telefone_celular || c.telefone_limpo || c.telefone ? (
              <p className="text-xs text-slate-600">📞 {c.telefone_celular || c.telefone_limpo || c.telefone}</p>
            ) : (
              <p className="text-xs text-red-500">Sem telefone</p>
            )}
            {c.cidade && <p className="text-xs text-slate-400">{c.cidade}</p>}
          </div>
        </div>
      </div>
    );
  }

  var mensagensRapidas = [
    "Olá! Estamos entrando em contato da HOME ON. Como podemos ajudar?",
    "Olá! Seu boleto está disponível para pagamento. Podemos enviar?",
    "Olá! Identificamos uma pendência em seu cadastro. Podemos ajudar?",
    "Olá! Temos uma promoção especial para você! Quer saber mais?",
    "Olá! Sua ordem de serviço foi concluída. Como ficou tudo?"
  ];

  function renderMensagemRapida(m, i) {
    return (
      <button 
        key={i}
        type="button"
        className={'text-left text-xs p-2 border rounded hover:bg-slate-50 ' + (mensagem === m ? 'border-blue-500 bg-blue-50' : '')}
        onClick={function() { setMensagem(m); }}
      >
        {m}
      </button>
    );
  }

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-xl p-6 w-full max-w-lg shadow-xl max-h-[90vh] overflow-y-auto" onClick={function(e) { e.stopPropagation(); }}>
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-semibold flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-green-600" />
            Iniciar Conversa no WhatsApp
          </h3>
          <Button variant="ghost" size="sm" onClick={onClose}>
            <X className="w-4 h-4" />
          </Button>
        </div>
        <div className="space-y-4">
          {/* Busca de Cliente */}
          <div className="relative">
            <div className="flex items-center justify-between mb-1">
              <label className="text-sm font-medium text-slate-700">Buscar Cliente</label>
              <div className="flex gap-1">
                <button
                  type="button"
                  className={'text-xs px-2 py-1 rounded ' + (fonte === 'ixc' ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-600')}
                  onClick={function() { setFonte('ixc'); setClientesBusca([]); }}
                >
                  IXCsoft
                </button>
                <button
                  type="button"
                  className={'text-xs px-2 py-1 rounded ' + (fonte === 'local' ? 'bg-blue-600 text-white' : 'bg-slate-100 text-slate-600')}
                  onClick={function() { setFonte('local'); setClientesBusca([]); }}
                >
                  Local
                </button>
              </div>
            </div>
            <div className="relative">
              <Input 
                placeholder={fonte === 'ixc' ? "Buscar por nome, CPF/CNPJ ou telefone no IXC..." : "Buscar cliente local..."}
                value={termoBusca}
                onChange={function(e) { buscarClientes(e.target.value); }}
                data-testid="busca-cliente-input"
              />
              {buscando && (
                <div className="absolute right-3 top-1/2 -translate-y-1/2">
                  <div className="animate-spin rounded-full h-4 w-4 border-2 border-blue-600 border-t-transparent"></div>
                </div>
              )}
            </div>
            {showClientes && clientesBusca.length > 0 && (
              <div className="absolute top-full left-0 right-0 bg-white border rounded-lg shadow-lg z-10 mt-1 max-h-60 overflow-y-auto">
                <div className="p-2 bg-slate-50 border-b text-xs text-slate-500">
                  {clientesBusca.length} cliente(s) encontrado(s) no {fonte === 'ixc' ? 'IXCsoft' : 'sistema local'}
                </div>
                {clientesBusca.map(renderClienteBusca)}
              </div>
            )}
            {showClientes && clientesBusca.length === 0 && termoBusca.length >= 2 && !buscando && (
              <div className="absolute top-full left-0 right-0 bg-white border rounded-lg shadow-lg z-10 mt-1 p-4 text-center text-slate-500 text-sm">
                Nenhum cliente encontrado
              </div>
            )}
          </div>

          {/* Nome do Cliente */}
          <div>
            <label className="text-sm font-medium text-slate-700">Nome do Cliente</label>
            <Input 
              placeholder="Nome do cliente" 
              value={nomeCliente}
              onChange={function(e) { setNomeCliente(e.target.value); }}
            />
          </div>

          {/* Telefone */}
          <div>
            <label className="text-sm font-medium text-slate-700">Telefone WhatsApp *</label>
            <div className="flex gap-2">
              <span className="flex items-center px-3 bg-slate-100 rounded-l-md border border-r-0 text-sm text-slate-600">+55</span>
              <Input 
                className="rounded-l-none"
                placeholder="11999999999" 
                value={telefone}
                onChange={function(e) { setTelefone(e.target.value.replace(/\D/g, '')); }}
                data-testid="telefone-input"
              />
            </div>
          </div>

          {/* Mensagens Rápidas */}
          <div>
            <label className="text-sm font-medium text-slate-700 mb-2 block">Mensagens Rápidas</label>
            <div className="grid grid-cols-1 gap-2 max-h-32 overflow-y-auto">
              {mensagensRapidas.map(renderMensagemRapida)}
            </div>
          </div>

          {/* Seleção de Canal */}
          <div>
            <label className="text-sm font-medium text-slate-700 mb-1 block">Canal de Envio *</label>
            {canais.length === 0 ? (
              <p className="text-sm text-red-500">Nenhum canal configurado. Configure em WhatsApp.</p>
            ) : (
              <select
                className="w-full p-2 border rounded-md bg-white"
                value={canalSelecionado}
                onChange={function(e) { setCanalSelecionado(e.target.value); }}
                data-testid="select-canal"
              >
                <option value="">Selecione um canal</option>
                {canais.map(function(canal) {
                  return (
                    <option key={canal.id} value={canal.id}>
                      {canal.nome} {canal.principal ? '(Principal)' : ''} - {canal.conectado ? 'Conectado' : 'Desconectado'}
                    </option>
                  );
                })}
              </select>
            )}
          </div>

          {/* Mensagem */}
          <div>
            <label className="text-sm font-medium text-slate-700">Mensagem *</label>
            <textarea 
              className="w-full border rounded-md p-3 text-sm min-h-[80px] focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Digite a mensagem..." 
              value={mensagem}
              onChange={function(e) { setMensagem(e.target.value); }}
              data-testid="mensagem-input"
            />
          </div>

          {/* Botões */}
          <div className="flex gap-2 pt-2">
            <Button variant="outline" onClick={onClose} className="flex-1">Cancelar</Button>
            <Button 
              onClick={handleIniciar} 
              className="flex-1 bg-green-600 hover:bg-green-700" 
              disabled={enviando}
              data-testid="iniciar-conversa-btn"
            >
              <Send className="w-4 h-4 mr-2" />
              {enviando ? 'Enviando...' : 'Enviar Mensagem'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

// Página Principal de Atendimentos
export default function AtendimentosPage() {
  var navigate = useNavigate();
  var atendimentosState = useState([]);
  var atendimentos = atendimentosState[0];
  var setAtendimentos = atendimentosState[1];
  var selectedState = useState(null);
  var selected = selectedState[0];
  var setSelected = selectedState[1];
  var respostaState = useState('');
  var resposta = respostaState[0];
  var setResposta = respostaState[1];
  var loadingState = useState(true);
  var loading = loadingState[0];
  var setLoading = loadingState[1];
  var statsState = useState({});
  var stats = statsState[0];
  var setStats = statsState[1];
  var buscaState = useState('');
  var busca = buscaState[0];
  var setBusca = buscaState[1];
  var operadoresState = useState([]);
  var operadores = operadoresState[0];
  var setOperadores = operadoresState[1];
  var somAtivadoState = useState(true);
  var somAtivado = somAtivadoState[0];
  var setSomAtivado = somAtivadoState[1];
  
  // Configurações avançadas de som
  var configSomState = useState(function() {
    var saved = localStorage.getItem('configSom');
    if (saved) {
      try { return JSON.parse(saved); } catch(e) {}
    }
    return {
      novaMensagem: true,        // Som a cada mensagem recebida
      novoAtendimento: true,     // Som apenas quando inicia novo atendimento
      semInteracao: true,        // Alerta de atendimento sem interação
      minutosInativo: 5          // Minutos sem interação para alertar
    };
  });
  var configSom = configSomState[0];
  var setConfigSom = configSomState[1];
  var showConfigSomState = useState(false);
  var showConfigSom = showConfigSomState[0];
  var setShowConfigSom = showConfigSomState[1];
  
  // Salvar config no localStorage quando mudar
  useEffect(function() {
    localStorage.setItem('configSom', JSON.stringify(configSom));
  }, [configSom]);
  
  // Filtro rápido pelos cards de estatísticas
  var filtroStatsState = useState(null); // null = todos, 'aguardando', 'aguardando_atendente', 'em_atendimento', 'hoje'
  var filtroStats = filtroStatsState[0];
  var setFiltroStats = filtroStatsState[1];
  
  // Filtros avançados
  var filtroStatusState = useState('todos');
  var filtroStatus = filtroStatusState[0];
  var setFiltroStatus = filtroStatusState[1];
  var filtroOperadorState = useState('todos');
  var filtroOperador = filtroOperadorState[0];
  var setFiltroOperador = filtroOperadorState[1];
  var filtroEspecialState = useState('todos');
  var filtroEspecial = filtroEspecialState[0];
  var setFiltroEspecial = filtroEspecialState[1];
  var filtroFilialState = useState('todos');
  var filtroFilial = filtroFilialState[0];
  var setFiltroFilial = filtroFilialState[1];
  
  // Estado para mensagem citada (responder mensagem específica)
  var mensagemCitadaState = useState(null);
  var mensagemCitada = mensagemCitadaState[0];
  var setMensagemCitada = mensagemCitadaState[1];
  
  // Modais
  var showCriarAtendenteState = useState(false);
  var showCriarAtendente = showCriarAtendenteState[0];
  var setShowCriarAtendente = showCriarAtendenteState[1];
  var showBuscarConversaState = useState(false);
  var showBuscarConversa = showBuscarConversaState[0];
  var setShowBuscarConversa = showBuscarConversaState[1];
  var showFiltrosState = useState(false);
  var showFiltros = showFiltrosState[0];
  var setShowFiltros = showFiltrosState[1];
  var showIniciarConversaState = useState(false);
  var showIniciarConversa = showIniciarConversaState[0];
  var setShowIniciarConversa = showIniciarConversaState[1];
  
  // Modal de Contatos
  var showContatosState = useState(false);
  var showContatos = showContatosState[0];
  var setShowContatos = showContatosState[1];
  
  // Modal de exportar/excluir conversa
  var showExportarState = useState(false);
  var showExportar = showExportarState[0];
  var setShowExportar = showExportarState[1];
  var exportandoState = useState(false);
  var exportando = exportandoState[0];
  var setExportando = exportandoState[1];
  var conversaExportadaState = useState(null);
  var conversaExportada = conversaExportadaState[0];
  var setConversaExportada = conversaExportadaState[1];
  
  var user = JSON.parse(localStorage.getItem('user') || '{}');
  var isSuperAdmin = user.is_super_admin === true;
  var podeExcluirAtendimentos = isSuperAdmin || (user.permissoes && user.permissoes.pode_excluir_atendimentos);
  
  // Mobile: mostrar chat em tela cheia
  var showMobileChatState = useState(false);
  var showMobileChat = showMobileChatState[0];
  var setShowMobileChat = showMobileChatState[1];
  
  // Sidebar colapsável
  var sidebarCollapsedState = useState(false);
  var sidebarCollapsed = sidebarCollapsedState[0];
  var setSidebarCollapsed = sidebarCollapsedState[1];
  
  // Modal de Histórico de Conversas
  var showHistoricoState = useState(false);
  var showHistorico = showHistoricoState[0];
  var setShowHistorico = showHistoricoState[1];
  var historicoConversasState = useState([]);
  var historicoConversas = historicoConversasState[0];
  var setHistoricoConversas = historicoConversasState[1];
  var loadingHistoricoState = useState(false);
  var loadingHistorico = loadingHistoricoState[0];
  var setLoadingHistorico = loadingHistoricoState[1];
  var historicoFiltrosState = useState({
    quantidade: 20,
    periodo: 'hoje',
    dataInicio: '',
    dataFim: '',
    atendente: ''
  });
  var historicoFiltros = historicoFiltrosState[0];
  var setHistoricoFiltros = historicoFiltrosState[1];
  var atendentesListaState = useState([]);
  var atendentesLista = atendentesListaState[0];
  var setAtendentesLista = atendentesListaState[1];
  
  // Detectar se é mobile
  var isMobileState = useState(false);
  var isMobile = isMobileState[0];
  var setIsMobile = isMobileState[1];
  
  useEffect(function() {
    function checkMobile() {
      setIsMobile(window.innerWidth < 768);
    }
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return function() { window.removeEventListener('resize', checkMobile); };
  }, []);

  // Respostas rápidas - carregadas do banco de dados
  var respostasRapidasState = useState([]);
  var respostasRapidas = respostasRapidasState[0];
  var setRespostasRapidas = respostasRapidasState[1];
  
  // Carregar respostas rápidas do banco de dados
  useEffect(function() {
    axios.get(API + '/atendimentos/respostas-rapidas', { headers: getAuthHeader() })
      .then(function(res) {
        var data = res.data;
        if (data && Array.isArray(data.respostas) && data.respostas.length > 0) {
          // Extrair o campo 'mensagem' de cada resposta
          var textos = data.respostas.map(function(r) { return r.mensagem || r.texto || r; });
          setRespostasRapidas(textos);
        } else if (Array.isArray(data) && data.length > 0) {
          var textos2 = data.map(function(r) { return r.mensagem || r.texto || r; });
          setRespostasRapidas(textos2);
        } else {
          // Fallback para respostas padrão
          setRespostasRapidas([
            "Olá! Como posso ajudar?",
            "Um momento, estou verificando...",
            "Vou transferir seu atendimento para o setor responsável.",
            "Obrigado pelo contato! Posso ajudar em mais alguma coisa?",
            "Seu problema foi resolvido. Tenha um ótimo dia!"
          ]);
        }
      })
      .catch(function() {
        // Em caso de erro, usar respostas padrão
        setRespostasRapidas([
          "Olá! Como posso ajudar?",
          "Um momento, estou verificando...",
          "Vou transferir seu atendimento para o setor responsável.",
          "Obrigado pelo contato! Posso ajudar em mais alguma coisa?",
          "Seu problema foi resolvido. Tenha um ótimo dia!"
        ]);
      });
  }, []);

  // Função para exportar conversa
  function exportarConversa(atendimentoId) {
    setExportando(true);
    axios.get(API + '/atendimentos/' + atendimentoId + '/exportar?formato=texto', { headers: getAuthHeader() })
      .then(function(res) {
        setConversaExportada(res.data);
        setShowExportar(true);
        setExportando(false);
      })
      .catch(function(err) {
        toast.error(err.response?.data?.detail || 'Erro ao exportar conversa');
        setExportando(false);
      });
  }

  // Função para baixar PDF
  function baixarPDF() {
    if (!conversaExportada) return;
    
    var conteudo = conversaExportada.conteudo;
    var protocolo = conversaExportada.protocolo;
    
    // Criar elemento para download
    var blob = new Blob([conteudo], { type: 'text/plain;charset=utf-8' });
    var url = window.URL.createObjectURL(blob);
    var a = document.createElement('a');
    a.href = url;
    a.download = 'atendimento_' + protocolo + '.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    
    toast.success('Arquivo baixado com sucesso!');
  }

  // Função para imprimir conversa
  function imprimirConversa() {
    if (!conversaExportada) return;
    
    var conteudo = conversaExportada.conteudo;
    var printWindow = window.open('', '_blank');
    printWindow.document.write('<html><head><title>Atendimento ' + conversaExportada.protocolo + '</title>');
    printWindow.document.write('<style>body { font-family: monospace; white-space: pre-wrap; padding: 20px; }</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(conteudo.replace(/\n/g, '<br>'));
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  }

  // Função para excluir atendimento
  function excluirAtendimento(atendimentoId) {
    if (!confirm('Tem certeza que deseja excluir esta conversa? Esta ação não pode ser desfeita e será registrada para fins de auditoria.')) {
      return;
    }
    
    axios.delete(API + '/atendimentos/' + atendimentoId, { headers: getAuthHeader() })
      .then(function(res) {
        toast.success(res.data.message);
        setShowExportar(false);
        setConversaExportada(null);
        setSelected(null);
        loadData();
      })
      .catch(function(err) {
        toast.error(err.response?.data?.detail || 'Erro ao excluir atendimento');
      });
  }

  useEffect(function() {
    loadData();
    loadOperadores();
    var interval = setInterval(loadData, 10000);
    return function() { clearInterval(interval); };
  }, []);

  // Auto-refresh da conversa aberta a cada 5 segundos
  useEffect(function() {
    if (!selected) return;
    
    var refreshChat = function() {
      axios.get(API + '/atendimento/' + selected.id, { headers: getAuthHeader() })
        .then(function(res) {
          var novosDados = res.data;
          
          // Verificar se há novas mensagens não lidas
          if (novosDados.nao_lidas > 0) {
            // Marcar como lido automaticamente pois a conversa está aberta
            axios.put(
              API + '/atendimentos/' + selected.id + '/marcar-lido',
              {},
              { headers: getAuthHeader() }
            ).then(function() {
              // Atualizar lista local para remover o badge
              setAtendimentos(function(prev) {
                return prev.map(function(a) {
                  if (a.id === selected.id) {
                    return { ...a, nao_lidas: 0 };
                  }
                  return a;
                });
              });
            }).catch(function(err) {
              console.error('Erro ao marcar como lido:', err);
            });
          }
          
          // Atualizar a conversa se ainda estiver aberta
          setSelected(function(current) {
            if (current && current.id === novosDados.id) {
              return { ...novosDados, nao_lidas: 0 }; // Forçar nao_lidas = 0 no selected
            }
            return current;
          });
        })
        .catch(function(err) {
          console.error('Erro ao atualizar chat:', err);
        });
    };
    
    // Executar imediatamente ao abrir a conversa
    refreshChat();
    
    var chatInterval = setInterval(refreshChat, 5000); // Atualiza a cada 5 segundos
    
    return function() { clearInterval(chatInterval); };
  }, [selected ? selected.id : null]); // Re-cria o intervalo quando muda o ID do atendimento

  function loadData() {
    var promises = [
      axios.get(API + '/atendimentos', { headers: getAuthHeader() }),
      axios.get(API + '/atendimentos/stats', { headers: getAuthHeader() })
    ];
    
    Promise.all(promises)
      .then(function(results) {
        var atendimentosData = results[0].data.atendimentos || results[0].data;
        var statsData = results[1].data;
        
        // Verificar novas mensagens e novos atendimentos
        var novasNaoLidas = atendimentosData.filter(function(a) { return a.nao_lidas > 0; }).length;
        var antigasNaoLidas = atendimentos.filter(function(a) { return a.nao_lidas > 0; }).length;
        
        // Verificar se é novo atendimento (não existia antes)
        var idsAntigos = atendimentos.map(function(a) { return a.id; });
        var novosAtendimentos = atendimentosData.filter(function(a) {
          return !idsAntigos.includes(a.id) && a.nao_lidas > 0;
        });
        
        // Verificar atendimentos sem interação há muito tempo
        var agora = new Date();
        var atdSemInteracao = atendimentosData.filter(function(a) {
          if (a.status === 'finalizado' || !a.updated_at) return false;
          var ultimaAtualizacao = new Date(a.updated_at);
          var minutos = (agora - ultimaAtualizacao) / (1000 * 60);
          return a.nao_lidas > 0 && minutos >= (configSom.minutosInativo || 5);
        });
        
        // Tocar som baseado nas configurações
        if (somAtivado) {
          var deveTocarSom = false;
          
          // Som para novo atendimento
          if (configSom.novoAtendimento && novosAtendimentos.length > 0) {
            deveTocarSom = true;
          }
          
          // Som para qualquer nova mensagem
          if (configSom.novaMensagem && novasNaoLidas > antigasNaoLidas && !deveTocarSom) {
            deveTocarSom = true;
          }
          
          // Som para atendimentos sem interação
          if (configSom.semInteracao && atdSemInteracao.length > 0) {
            // Verificar se já alertou sobre esses atendimentos recentemente
            var alertadosRecentemente = JSON.parse(sessionStorage.getItem('alertadosSemInteracao') || '[]');
            var novosParaAlertar = atdSemInteracao.filter(function(a) {
              return !alertadosRecentemente.includes(a.id);
            });
            
            if (novosParaAlertar.length > 0) {
              deveTocarSom = true;
              // Marcar como alertado
              var novosAlertados = alertadosRecentemente.concat(novosParaAlertar.map(function(a) { return a.id; }));
              sessionStorage.setItem('alertadosSemInteracao', JSON.stringify(novosAlertados));
              
              // Toast de aviso
              toast.warning(novosParaAlertar.length + ' atendimento(s) aguardando há mais de ' + (configSom.minutosInativo || 5) + ' minutos', {
                duration: 5000
              });
            }
          }
          
          if (deveTocarSom) {
            playNotificationSound();
          }
        }
        
        setAtendimentos(atendimentosData);
        setStats(statsData);
        setLoading(false);
      })
      .catch(function() {
        toast.error('Erro ao carregar dados');
        setLoading(false);
      });
  }

  function loadOperadores() {
    axios.get(API + '/atendimentos/operadores', { headers: getAuthHeader() })
      .then(function(res) {
        setOperadores(res.data.operadores || []);
      })
      .catch(function() {});
  }

  // Carregar lista de atendentes para o filtro de histórico
  function loadAtendentesLista() {
    axios.get(API + '/users', { headers: getAuthHeader() })
      .then(function(res) {
        var usuarios = res.data || [];
        // Filtrar apenas usuários com permissão de atendimentos ou super admin
        var atendentes = usuarios.filter(function(u) {
          return u.is_super_admin || (u.permissoes && u.permissoes.atendimentos);
        });
        setAtendentesLista(atendentes);
      })
      .catch(function() {});
  }

  // Carregar histórico de conversas com filtros
  function loadHistorico() {
    setLoadingHistorico(true);
    
    var params = new URLSearchParams();
    params.append('limite', historicoFiltros.quantidade);
    params.append('status', 'finalizado');  // Status correto no banco
    
    // Calcular datas baseado no período
    var hoje = new Date();
    var dataInicio, dataFim;
    
    if (historicoFiltros.periodo === 'hoje') {
      dataInicio = new Date(hoje.setHours(0, 0, 0, 0));
      dataFim = new Date();
    } else if (historicoFiltros.periodo === 'ontem') {
      var ontem = new Date(hoje);
      ontem.setDate(ontem.getDate() - 1);
      dataInicio = new Date(ontem.setHours(0, 0, 0, 0));
      dataFim = new Date(ontem.setHours(23, 59, 59, 999));
    } else if (historicoFiltros.periodo === 'semana') {
      var semana = new Date(hoje);
      semana.setDate(semana.getDate() - 7);
      dataInicio = semana;
      dataFim = new Date();
    } else if (historicoFiltros.periodo === 'data' && historicoFiltros.dataInicio) {
      dataInicio = new Date(historicoFiltros.dataInicio);
      dataFim = historicoFiltros.dataFim ? new Date(historicoFiltros.dataFim) : new Date();
    }
    
    if (dataInicio) {
      params.append('data_inicio', dataInicio.toISOString());
    }
    if (dataFim) {
      params.append('data_fim', dataFim.toISOString());
    }
    if (historicoFiltros.atendente) {
      params.append('atendente_id', historicoFiltros.atendente);
    }
    
    axios.get(API + '/atendimentos/historico?' + params.toString(), { headers: getAuthHeader() })
      .then(function(res) {
        var conversas = res.data.atendimentos || res.data || [];
        setHistoricoConversas(conversas);
        setLoadingHistorico(false);
      })
      .catch(function() {
        toast.error('Erro ao carregar histórico');
        setLoadingHistorico(false);
        setHistoricoConversas([]);
      });
  }

  // Abrir modal de histórico
  function abrirHistorico() {
    loadAtendentesLista();
    setShowHistorico(true);
    loadHistorico();
  }

  function enviarResposta() {
    if (!selected || !resposta.trim()) return;
    
    // Preparar dados com citação se houver
    var url = API + '/atendimentos/' + selected.id + '/responder?mensagem=' + encodeURIComponent(resposta);
    if (mensagemCitada) {
      url += '&citacao_id=' + encodeURIComponent(mensagemCitada.id || '');
      url += '&citacao_texto=' + encodeURIComponent(mensagemCitada.mensagem ? mensagemCitada.mensagem.substring(0, 100) : '');
      url += '&citacao_remetente=' + encodeURIComponent(mensagemCitada.nome_remetente || '');
    }
    
    axios.post(
      url,
      {},
      { headers: getAuthHeader() }
    ).then(function(res) {
      setSelected(res.data);
      setResposta('');
      setMensagemCitada(null); // Limpar citação após enviar
      loadData();
    }).catch(function() { toast.error('Erro ao enviar'); });
  }

  function finalizar(id) {
    axios.put(API + '/atendimentos/' + id + '/finalizar', {}, { headers: getAuthHeader() })
      .then(function() {
        toast.success('Atendimento finalizado!');
        setSelected(null);
        loadData();
      })
      .catch(function(err) { 
        toast.error(err.response?.data?.detail || 'Erro ao finalizar'); 
      });
  }

  function assumir(id) {
    axios.put(API + '/atendimentos/' + id + '/assumir', {}, { headers: getAuthHeader() })
      .then(function(res) {
        toast.success('Atendimento assumido!');
        setSelected(res.data);
        loadData();
      })
      .catch(function(err) { toast.error(err.response?.data?.detail || 'Erro ao assumir'); });
  }

  function abrirChat(atend) {
    axios.get(API + '/atendimento/' + atend.id)
      .then(function(res) { 
        setSelected(res.data);
        if (isMobile) {
          setShowMobileChat(true);
        }
        
        // Marcar como lido se tiver mensagens não lidas
        if (atend.nao_lidas > 0) {
          axios.put(
            API + '/atendimentos/' + atend.id + '/marcar-lido',
            {},
            { headers: getAuthHeader() }
          ).then(function() {
            // Atualizar lista local para remover o badge
            setAtendimentos(function(prev) {
              return prev.map(function(a) {
                if (a.id === atend.id) {
                  return { ...a, nao_lidas: 0 };
                }
                return a;
              });
            });
          }).catch(function(err) {
            console.error('Erro ao marcar como lido:', err);
          });
        }
      })
      .catch(function() { toast.error('Erro ao abrir chat'); });
  }
  
  function fecharChatMobile() {
    setShowMobileChat(false);
  }

  function transferir(novoOperadorId) {
    if (!selected) return;
    axios.put(
      API + '/atendimentos/' + selected.id + '/transferir?novo_operador_id=' + novoOperadorId,
      {},
      { headers: getAuthHeader() }
    ).then(function() {
      toast.success('Atendimento transferido!');
      setSelected(null);
      loadData();
    }).catch(function(err) { toast.error(err.response?.data?.detail || 'Erro ao transferir'); });
  }

  function atualizarPrioridade(id, prioridade) {
    axios.put(
      API + '/atendimentos/' + id + '/prioridade?prioridade=' + prioridade,
      {},
      { headers: getAuthHeader() }
    ).then(function() {
      toast.success('Prioridade atualizada!');
      loadData();
      if (selected && selected.id === id) {
        axios.get(API + '/atendimento/' + id).then(function(r) { setSelected(r.data); });
      }
    }).catch(function() { toast.error('Erro ao atualizar prioridade'); });
  }

  function criarAtendente(dados) {
    return axios.post(API + '/users', {
      username: dados.username,
      password: dados.password,
      name: dados.nome,
      is_super_admin: false,
      permissoes: {
        dashboard: true,
        atendimentos: true,
        chat_interno: true,
        mensagens: true
      }
    }, { headers: getAuthHeader() })
    .then(function() {
      toast.success('Atendente criado com sucesso!');
      loadOperadores();
    })
    .catch(function(err) { 
      toast.error(err.response?.data?.detail || 'Erro ao criar atendente'); 
      throw err;
    });
  }

  function buscarConversa(dados) {
    var params = [];
    if (dados.protocolo) params.push('protocolo=' + encodeURIComponent(dados.protocolo));
    if (dados.telefone) params.push('telefone=' + encodeURIComponent(dados.telefone));
    params.push('incluir_finalizados=true');
    
    return axios.get(API + '/atendimentos?' + params.join('&'), { headers: getAuthHeader() })
      .then(function(res) {
        return res.data.atendimentos || res.data || [];
      })
      .catch(function() {
        toast.error('Erro ao buscar');
        return [];
      });
  }

  function iniciarConversa(dados) {
    // Usar o novo endpoint que suporta múltiplos canais
    var payload = {
      telefone: dados.telefone,
      nome: dados.nome_cliente || null,
      canal_id: dados.canal_id,
      mensagem_inicial: dados.mensagem
    };
    
    return axios.post(API + '/atendimentos/novo', payload, { headers: getAuthHeader() })
      .then(function(res) {
        toast.success('Conversa iniciada com sucesso!');
        loadData();
        if (res.data.atendimento) {
          setSelected(res.data.atendimento);
        }
      })
      .catch(function(err) {
        toast.error(err.response?.data?.detail || 'Erro ao iniciar conversa');
        throw err;
      });
  }

  // Filtrar atendimentos
  var atendimentosFiltrados = atendimentos.filter(function(a) {
    // Filtro pelos cards de estatísticas (prioridade)
    if (filtroStats) {
      if (filtroStats === 'aguardando' && a.status !== 'aguardando') return false;
      if (filtroStats === 'aguardando_atendente' && (a.status !== 'aguardando' || a.operador_id)) return false;
      if (filtroStats === 'em_atendimento' && a.status !== 'em_atendimento') return false;
      if (filtroStats === 'hoje') {
        if (!a.created_at) return false;
        var dataHoje = new Date();
        var dataAtendimento = new Date(a.created_at);
        if (dataHoje.toDateString() !== dataAtendimento.toDateString()) return false;
      }
    }
    
    // Busca por texto
    if (busca) {
      var buscaLower = busca.toLowerCase();
      var matchBusca = (a.nome && a.nome.toLowerCase().includes(buscaLower)) ||
                       (a.telefone && a.telefone.includes(busca)) ||
                       (a.protocolo && a.protocolo.includes(busca));
      if (!matchBusca) return false;
    }
    
    // Filtro por status (só aplica se não tiver filtro de stats)
    if (!filtroStats && filtroStatus !== 'todos' && a.status !== filtroStatus) return false;
    
    // Filtro por operador
    if (filtroOperador !== 'todos' && a.operador_id !== filtroOperador) return false;
    
    // Filtros especiais
    if (filtroEspecial === 'nao_lidas' && (!a.nao_lidas || a.nao_lidas === 0)) return false;
    if (filtroEspecial === 'esquecidas') {
      if (!a.updated_at || a.status === 'finalizado') return false;
      var lastUpdate = new Date(a.updated_at);
      var diff = (new Date() - lastUpdate) / 60000;
      if (diff < 30) return false;
    }
    
    // Filtro por filial
    if (filtroFilial !== 'todos') {
      if (filtroFilial === 'sem_filial') {
        if (a.filial) return false;
      } else if (a.filial !== filtroFilial) {
        return false;
      }
    }
    
    return true;
  }).sort(function(a, b) {
    // 1. Prioridade máxima: mensagens não lidas (nao_lidas > 0)
    var aNaoLida = (a.nao_lidas || 0) > 0 ? 1 : 0;
    var bNaoLida = (b.nao_lidas || 0) > 0 ? 1 : 0;
    if (aNaoLida !== bNaoLida) return bNaoLida - aNaoLida;
    
    // 2. Segunda prioridade: aguardando sem operador
    var aAguardando = (a.status === 'aguardando' && !a.operador_id) ? 1 : 0;
    var bAguardando = (b.status === 'aguardando' && !b.operador_id) ? 1 : 0;
    if (aAguardando !== bAguardando) return bAguardando - aAguardando;
    
    // 3. Terceira prioridade: em_atendimento antes de finalizado
    var statusOrdem = { 'em_atendimento': 1, 'aguardando': 2, 'finalizado': 3 };
    var aStatusOrdem = statusOrdem[a.status] || 2;
    var bStatusOrdem = statusOrdem[b.status] || 2;
    if (aStatusOrdem !== bStatusOrdem) return aStatusOrdem - bStatusOrdem;
    
    // 4. Por último: ordenar por última atualização (mais recente primeiro)
    var aTime = a.updated_at ? new Date(a.updated_at).getTime() : 0;
    var bTime = b.updated_at ? new Date(b.updated_at).getTime() : 0;
    return bTime - aTime;
  });

  // Contadores para filtros especiais
  var countNaoLidas = atendimentos.filter(function(a) { return a.nao_lidas > 0; }).length;
  var countEsquecidas = atendimentos.filter(function(a) {
    if (!a.updated_at || a.status === 'finalizado') return false;
    var diff = (new Date() - new Date(a.updated_at)) / 60000;
    return diff > 30;
  }).length;

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <RefreshCw className="w-8 h-8 animate-spin text-blue-600" />
      </div>
    );
  }

  function renderAtendimento(a) {
    return (
      <AtendimentoItem 
        key={a.id} 
        atendimento={a} 
        isSelected={selected && selected.id === a.id}
        onClick={function() { abrirChat(a); }}
      />
    );
  }

  function renderOperadorFiltro(op) {
    return (
      <option key={op.id} value={op.id}>{op.name}</option>
    );
  }

  return (
    <div className="h-full flex flex-col md:flex-row" data-testid="atendimentos-page">
      {/* Botão para abrir sidebar quando colapsado */}
      {sidebarCollapsed && !isMobile && (
        <div className="flex-none w-14 bg-slate-800 flex flex-col items-center py-4 gap-3">
          <Button 
            variant="ghost" 
            size="icon"
            onClick={function() { setSidebarCollapsed(false); }}
            className="text-white hover:bg-white/20 w-10 h-10"
            title="Expandir menu"
          >
            <Menu className="w-5 h-5" />
          </Button>
          <div className="w-8 h-px bg-white/20" />
          <div className="flex flex-col items-center gap-2">
            <div className="w-8 h-8 rounded-full bg-amber-500 flex items-center justify-center text-white text-xs font-bold" title="Aguardando">
              {stats.aguardando || 0}
            </div>
            <div className="w-8 h-8 rounded-full bg-red-500 flex items-center justify-center text-white text-xs font-bold" title="Sem Atendente">
              {stats.aguardando_atendente || 0}
            </div>
            <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white text-xs font-bold" title="Em Atendimento">
              {stats.em_atendimento || 0}
            </div>
          </div>
          <div className="w-8 h-px bg-white/20" />
          <Button 
            variant="ghost" 
            size="icon"
            onClick={function() { setShowIniciarConversa(true); }}
            className="text-white hover:bg-green-600 w-10 h-10"
            title="Iniciar conversa"
          >
            <MessageSquare className="w-5 h-5" />
          </Button>
          <Button 
            variant="ghost" 
            size="icon"
            onClick={loadData}
            className="text-white hover:bg-white/20 w-10 h-10"
            title="Atualizar"
          >
            <RefreshCw className="w-5 h-5" />
          </Button>
        </div>
      )}

      {/* Sidebar com lista - esconde no mobile quando chat está aberto */}
      <div className={'flex-none flex flex-col bg-white border-r overflow-hidden transition-all duration-300 ' + 
        (isMobile && showMobileChat ? 'hidden' : '') + 
        (sidebarCollapsed && !isMobile ? 'hidden' : ' ') +
        (isMobile ? ' flex-1' : ' w-80 lg:w-96')}>
        {/* Header - Azul Marinho HELP4PRIME */}
        <div className="p-3 border-b bg-gradient-to-r from-slate-800 to-slate-900 text-white">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-base font-bold flex items-center gap-2">
              <MessageCircle className="w-5 h-5" />
              Atendimentos
            </h2>
            <div className="flex items-center gap-1">
              <div className="relative">
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={function() { setSomAtivado(!somAtivado); }}
                  onContextMenu={function(e) { e.preventDefault(); setShowConfigSom(true); }}
                  title={somAtivado ? 'Clique para desativar som | Clique direito para configurações' : 'Clique para ativar som | Clique direito para configurações'}
                  className="p-2 text-white hover:bg-white/20"
                >
                  {somAtivado ? <Volume2 className="w-4 h-4" /> : <VolumeX className="w-4 h-4" />}
                </Button>
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={function() { setShowConfigSom(true); }}
                  title="Configurar notificações de som"
                  className="p-1 text-white hover:bg-white/20 absolute -bottom-1 -right-1 bg-slate-700 rounded-full w-4 h-4 flex items-center justify-center text-[8px]"
                >
                  ⚙
                </Button>
              </div>
              <Button variant="ghost" size="sm" onClick={loadData} title="Atualizar" className="p-2 text-white hover:bg-white/20">
                <RefreshCw className="w-4 h-4" />
              </Button>
              {!isMobile && (
                <Button 
                  variant="ghost" 
                  size="sm" 
                  onClick={function() { setSidebarCollapsed(true); }}
                  title="Recolher menu"
                  className="p-2 text-white hover:bg-white/20"
                >
                  <PanelLeftClose className="w-4 h-4" />
                </Button>
              )}
            </div>
          </div>

          {/* Stats Cards Compactos - Clicáveis para filtrar */}
          <div className="grid grid-cols-4 gap-1 mb-3">
            <div 
              className={'rounded p-1.5 text-center cursor-pointer transition-all ' + 
                (filtroStats === 'aguardando' ? 'bg-white/30 ring-2 ring-white' : 'bg-white/10 hover:bg-white/20')}
              onClick={function() { setFiltroStats(filtroStats === 'aguardando' ? null : 'aguardando'); }}
              title="Clique para filtrar atendimentos aguardando"
            >
              <p className="text-lg font-bold">{stats.aguardando || 0}</p>
              <p className="text-[9px] opacity-80">Aguard.</p>
            </div>
            <div 
              className={'rounded p-1.5 text-center cursor-pointer transition-all ' + 
                (filtroStats === 'aguardando_atendente' ? 'bg-red-500/50 ring-2 ring-red-300' : 'bg-white/10 hover:bg-white/20')}
              onClick={function() { setFiltroStats(filtroStats === 'aguardando_atendente' ? null : 'aguardando_atendente'); }}
              title="Clique para filtrar atendimentos sem atendente"
            >
              <p className="text-lg font-bold text-red-300">{stats.aguardando_atendente || 0}</p>
              <p className="text-[9px] opacity-80">S/ Atend.</p>
            </div>
            <div 
              className={'rounded p-1.5 text-center cursor-pointer transition-all ' + 
                (filtroStats === 'em_atendimento' ? 'bg-blue-500/50 ring-2 ring-blue-300' : 'bg-white/10 hover:bg-white/20')}
              onClick={function() { setFiltroStats(filtroStats === 'em_atendimento' ? null : 'em_atendimento'); }}
              title="Clique para filtrar atendimentos em andamento"
            >
              <p className="text-lg font-bold text-blue-300">{stats.em_atendimento || 0}</p>
              <p className="text-[9px] opacity-80">Em Atend.</p>
            </div>
            <div 
              className={'rounded p-1.5 text-center cursor-pointer transition-all ' + 
                (filtroStats === 'hoje' ? 'bg-green-500/50 ring-2 ring-green-300' : 'bg-white/10 hover:bg-white/20')}
              onClick={function() { setFiltroStats(filtroStats === 'hoje' ? null : 'hoje'); }}
              title="Clique para filtrar atendimentos de hoje"
            >
              <p className="text-lg font-bold text-green-300">{stats.hoje || 0}</p>
              <p className="text-[9px] opacity-80">Hoje</p>
            </div>
          </div>
          
          {/* Indicador de filtro ativo */}
          {filtroStats && (
            <div className="mb-2 flex items-center justify-between bg-yellow-500/20 rounded px-2 py-1">
              <span className="text-xs text-yellow-200">
                Filtro: {filtroStats === 'aguardando' ? 'Aguardando' : 
                         filtroStats === 'aguardando_atendente' ? 'Sem Atendente' : 
                         filtroStats === 'em_atendimento' ? 'Em Atendimento' : 'Hoje'}
              </span>
              <button 
                onClick={function() { setFiltroStats(null); }}
                className="text-yellow-200 hover:text-white text-xs"
              >
                ✕ Limpar
              </button>
            </div>
          )}

          {/* Ações Rápidas */}
          <div className="flex gap-2">
            <Button 
              size="sm" 
              className="flex-1 text-xs bg-green-600 hover:bg-green-700"
              onClick={function() { setShowIniciarConversa(true); }}
              data-testid="iniciar-conversa-modal-btn"
            >
              <MessageSquare className="w-3 h-3 mr-1" />Nova Conversa
            </Button>
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-xs text-white hover:bg-white/20"
              onClick={function() { navigate('/transmissao'); }}
              data-testid="btn-lista-transmissao"
              title="Lista de Transmissão"
            >
              <Radio className="w-4 h-4" />
            </Button>
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-xs text-white hover:bg-white/20"
              onClick={function() { setShowBuscarConversa(true); }}
              data-testid="buscar-conversa-btn"
            >
              <Search className="w-4 h-4" />
            </Button>
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-xs text-white hover:bg-white/20"
              onClick={abrirHistorico}
              data-testid="historico-conversas-btn"
              title="Histórico de Conversas"
            >
              <History className="w-4 h-4" />
            </Button>
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-xs text-white hover:bg-white/20"
              onClick={function() { setShowContatos(true); }}
              data-testid="contatos-btn"
              title="Contatos"
            >
              <Users className="w-4 h-4" />
            </Button>
          </div>
        </div>

        {/* Busca e Filtros */}
        <div className="p-3 border-b bg-slate-50">
          <div className="relative mb-2">
            <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
            <Input 
              className="pl-9" 
              placeholder="Buscar por nome, telefone, protocolo..." 
              value={busca}
              onChange={function(e) { setBusca(e.target.value); }}
              data-testid="busca-input"
            />
          </div>

          {/* Filtros Rápidos */}
          <div className="flex gap-2 flex-wrap mb-3">
            <Button 
              variant={filtroEspecial === 'nao_lidas' ? 'default' : 'outline'} 
              size="sm" 
              className={'text-xs ' + (filtroEspecial === 'nao_lidas' ? 'bg-red-600' : '')}
              onClick={function() { setFiltroEspecial(filtroEspecial === 'nao_lidas' ? 'todos' : 'nao_lidas'); }}
              data-testid="filtro-nao-lidas"
            >
              <Eye className="w-3 h-3 mr-1" />
              Não Lidas ({countNaoLidas})
            </Button>
            <Button 
              variant={filtroEspecial === 'esquecidas' ? 'default' : 'outline'} 
              size="sm" 
              className={'text-xs ' + (filtroEspecial === 'esquecidas' ? 'bg-orange-600' : '')}
              onClick={function() { setFiltroEspecial(filtroEspecial === 'esquecidas' ? 'todos' : 'esquecidas'); }}
              data-testid="filtro-esquecidas"
            >
              <AlertCircle className="w-3 h-3 mr-1" />
              Esquecidas ({countEsquecidas})
            </Button>
            <Button 
              variant={showFiltros ? 'default' : 'outline'} 
              size="sm" 
              className="text-xs"
              onClick={function() { setShowFiltros(!showFiltros); }}
              data-testid="toggle-filtros"
            >
              <Filter className="w-3 h-3 mr-1" />Filtros
            </Button>
          </div>

          {/* Filtros Avançados */}
          {showFiltros && (
            <div className="bg-slate-50 rounded-lg p-3 space-y-3">
              <div>
                <label className="text-xs font-medium text-slate-600">Status</label>
                <select 
                  className="w-full mt-1 text-sm border rounded-md p-2"
                  value={filtroStatus}
                  onChange={function(e) { setFiltroStatus(e.target.value); }}
                  data-testid="filtro-status"
                >
                  <option value="todos">Todos</option>
                  <option value="aguardando">Aguardando</option>
                  <option value="aguardando_atendente">Aguardando Atendente</option>
                  <option value="em_atendimento">Em Atendimento</option>
                  <option value="finalizado">Finalizado</option>
                </select>
              </div>
              <div>
                <label className="text-xs font-medium text-slate-600">Atendente</label>
                <select 
                  className="w-full mt-1 text-sm border rounded-md p-2"
                  value={filtroOperador}
                  onChange={function(e) { setFiltroOperador(e.target.value); }}
                  data-testid="filtro-operador"
                >
                  <option value="todos">Todos</option>
                  {operadores.map(renderOperadorFiltro)}
                </select>
              </div>
              <div>
                <label className="text-xs font-medium text-slate-600">Filial</label>
                <select 
                  className="w-full mt-1 text-sm border rounded-md p-2"
                  value={filtroFilial}
                  onChange={function(e) { setFiltroFilial(e.target.value); }}
                  data-testid="filtro-filial"
                >
                  <option value="todos">Todas</option>
                  <option value="Passa Quatro">🔵 Passa Quatro (P4)</option>
                  <option value="São Paulo">🟢 São Paulo (SP)</option>
                  <option value="sem_filial">⚪ Sem Filial</option>
                </select>
              </div>
              <Button 
                variant="outline" 
                size="sm" 
                className="w-full text-xs"
                onClick={function() { 
                  setFiltroStatus('todos'); 
                  setFiltroOperador('todos'); 
                  setFiltroEspecial('todos');
                  setFiltroFilial('todos'); 
                }}
              >
                Limpar Filtros
              </Button>
            </div>
          )}
        </div>

        {/* Lista de Atendimentos */}
        <div className="flex-1 overflow-y-auto p-3 space-y-2">
          {atendimentosFiltrados.length === 0 ? (
            <div className="text-center py-8 text-slate-400">
              <Inbox className="w-12 h-12 mx-auto mb-2 opacity-50" />
              <p>Nenhum atendimento encontrado</p>
            </div>
          ) : atendimentosFiltrados.map(renderAtendimento)}
        </div>
      </div>

      {/* Chat Panel - No mobile, só mostra quando showMobileChat está true */}
      {(!isMobile || showMobileChat) && (
        <ChatPanel 
          selected={selected}
          resposta={resposta}
          setResposta={setResposta}
          enviarResposta={enviarResposta}
          assumir={assumir}
          finalizar={finalizar}
          onClose={function() { setSelected(null); setShowMobileChat(false); }}
          respostasRapidas={respostasRapidas}
          operadores={operadores}
          onTransferir={transferir}
          // onBuscarBoleto removido - fluxo de confirmação implementado no ChatPanel
          onAtualizarPrioridade={atualizarPrioridade}
          isMobile={isMobile}
          onVoltar={fecharChatMobile}
          exportando={exportando}
          onExportar={exportarConversa}
          mensagemCitada={mensagemCitada}
          setMensagemCitada={setMensagemCitada}
          onUpdateSelected={setSelected}
        />
      )}

      {/* Modais */}
      <ModalCriarAtendente 
        isOpen={showCriarAtendente}
        onClose={function() { setShowCriarAtendente(false); }}
        onSave={criarAtendente}
      />
      <ModalBuscarConversa 
        isOpen={showBuscarConversa}
        onClose={function() { setShowBuscarConversa(false); }}
        onSearch={buscarConversa}
        onVisualizar={function(atendimento) { setSelected(atendimento); setShowBuscarConversa(false); }}
        onExportar={exportarConversa}
      />
      <ModalIniciarConversa 
        isOpen={showIniciarConversa}
        onClose={function() { setShowIniciarConversa(false); }}
        onIniciar={iniciarConversa}
      />
      
      {/* Modal Contatos */}
      {showContatos && (
        <ModalContatos 
          isOpen={showContatos}
          onClose={function() { setShowContatos(false); }}
        />
      )}
      
      {/* Modal Exportar Conversa */}
      {showExportar && conversaExportada && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl max-w-4xl w-full max-h-[90vh] flex flex-col">
            <div className="p-4 border-b flex items-center justify-between bg-slate-50 rounded-t-xl">
              <div>
                <h2 className="font-bold text-lg text-slate-800">Registro de Atendimento</h2>
                <p className="text-sm text-slate-500">Protocolo: #{conversaExportada.protocolo}</p>
              </div>
              <Button variant="ghost" size="sm" onClick={function() { setShowExportar(false); setConversaExportada(null); }}>
                <X className="w-5 h-5" />
              </Button>
            </div>
            
            <div className="flex-1 overflow-auto p-4">
              {/* Dados do Atendimento */}
              <div className="grid md:grid-cols-2 gap-4 mb-4">
                <div className="bg-blue-50 rounded-lg p-3">
                  <h3 className="font-semibold text-blue-800 mb-2">Dados do Atendimento</h3>
                  <div className="space-y-1 text-sm">
                    <p><span className="text-slate-500">Status:</span> <span className="font-medium">{conversaExportada.atendimento?.status}</span></p>
                    <p><span className="text-slate-500">Categoria:</span> <span className="font-medium">{conversaExportada.atendimento?.categoria || 'N/A'}</span></p>
                    <p><span className="text-slate-500">Canal:</span> <span className="font-medium">{conversaExportada.atendimento?.canal}</span></p>
                    <p><span className="text-slate-500">Início:</span> <span className="font-medium">{new Date(conversaExportada.atendimento?.created_at).toLocaleString('pt-BR')}</span></p>
                  </div>
                </div>
                <div className="bg-green-50 rounded-lg p-3">
                  <h3 className="font-semibold text-green-800 mb-2">Dados do Cliente</h3>
                  <div className="space-y-1 text-sm">
                    <p><span className="text-slate-500">Nome:</span> <span className="font-medium">{conversaExportada.cliente?.razao || conversaExportada.atendimento?.nome || 'N/A'}</span></p>
                    <p><span className="text-slate-500">CPF/CNPJ:</span> <span className="font-medium">{conversaExportada.cliente?.cpf_cnpj || 'N/A'}</span></p>
                    <p><span className="text-slate-500">Telefone:</span> <span className="font-medium">{conversaExportada.atendimento?.telefone}</span></p>
                    <p><span className="text-slate-500">Email:</span> <span className="font-medium">{conversaExportada.cliente?.email || 'N/A'}</span></p>
                  </div>
                </div>
              </div>
              
              {/* Histórico da Conversa */}
              <div className="border rounded-lg">
                <div className="bg-slate-100 px-3 py-2 border-b">
                  <h3 className="font-semibold text-slate-700">Histórico da Conversa ({conversaExportada.atendimento?.mensagens?.length || 0} mensagens)</h3>
                </div>
                <div className="p-3 max-h-[400px] overflow-y-auto space-y-3">
                  {conversaExportada.atendimento?.mensagens?.map(function(msg, idx) {
                    var isCliente = msg.remetente === 'cliente';
                    var isSistema = msg.remetente === 'sistema';
                    return (
                      <div key={idx} className={'p-3 rounded-lg ' + (isCliente ? 'bg-slate-100 ml-0 mr-12' : isSistema ? 'bg-amber-50 mx-6' : 'bg-blue-100 ml-12 mr-0')}>
                        <div className="flex items-center justify-between mb-1">
                          <span className={'font-medium text-sm ' + (isCliente ? 'text-slate-700' : isSistema ? 'text-amber-700' : 'text-blue-700')}>
                            {msg.nome_remetente || msg.remetente}
                          </span>
                          <span className="text-xs text-slate-400">{new Date(msg.timestamp).toLocaleString('pt-BR')}</span>
                        </div>
                        <p className="text-sm text-slate-800 whitespace-pre-wrap">{msg.mensagem}</p>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            
            {/* Ações */}
            <div className="p-4 border-t bg-slate-50 rounded-b-xl flex flex-wrap gap-2 justify-between">
              <div className="flex gap-2">
                <Button onClick={baixarPDF} className="bg-blue-600 hover:bg-blue-700">
                  <Download className="w-4 h-4 mr-2" />
                  Baixar TXT
                </Button>
                <Button onClick={imprimirConversa} variant="outline">
                  <Printer className="w-4 h-4 mr-2" />
                  Imprimir
                </Button>
              </div>
              {podeExcluirAtendimentos && (
                <Button 
                  onClick={function() { excluirAtendimento(conversaExportada.atendimento?.id); }}
                  variant="destructive"
                  className="bg-red-600 hover:bg-red-700"
                >
                  <Trash2 className="w-4 h-4 mr-2" />
                  Excluir Conversa
                </Button>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Histórico de Conversas */}
      {showHistorico && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
            {/* Header */}
            <div className="p-4 border-b bg-gradient-to-r from-slate-800 to-slate-900 text-white flex items-center justify-between">
              <div className="flex items-center gap-2">
                <History className="w-5 h-5" />
                <h2 className="text-lg font-bold">Histórico de Conversas</h2>
              </div>
              <Button 
                variant="ghost" 
                size="sm" 
                onClick={function() { setShowHistorico(false); }}
                className="text-white hover:bg-white/20"
              >
                <X className="w-5 h-5" />
              </Button>
            </div>

            {/* Filtros */}
            <div className="p-4 border-b bg-slate-50 space-y-3">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                {/* Quantidade */}
                <div>
                  <label className="text-xs font-medium text-slate-600 mb-1 block">Quantidade</label>
                  <select
                    value={historicoFiltros.quantidade}
                    onChange={function(e) { 
                      setHistoricoFiltros(Object.assign({}, historicoFiltros, { quantidade: parseInt(e.target.value) }));
                    }}
                    className="w-full h-9 rounded-md border border-slate-300 bg-white px-3 text-sm"
                  >
                    <option value="10">10 conversas</option>
                    <option value="20">20 conversas</option>
                    <option value="30">30 conversas</option>
                    <option value="50">50 conversas</option>
                    <option value="100">100 conversas</option>
                  </select>
                </div>

                {/* Período */}
                <div>
                  <label className="text-xs font-medium text-slate-600 mb-1 block">Período</label>
                  <select
                    value={historicoFiltros.periodo}
                    onChange={function(e) { 
                      setHistoricoFiltros(Object.assign({}, historicoFiltros, { periodo: e.target.value }));
                    }}
                    className="w-full h-9 rounded-md border border-slate-300 bg-white px-3 text-sm"
                  >
                    <option value="hoje">Hoje</option>
                    <option value="ontem">Ontem</option>
                    <option value="semana">Última Semana</option>
                    <option value="data">Data específica</option>
                  </select>
                </div>

                {/* Atendente */}
                <div>
                  <label className="text-xs font-medium text-slate-600 mb-1 block">Atendente</label>
                  <select
                    value={historicoFiltros.atendente}
                    onChange={function(e) { 
                      setHistoricoFiltros(Object.assign({}, historicoFiltros, { atendente: e.target.value }));
                    }}
                    className="w-full h-9 rounded-md border border-slate-300 bg-white px-3 text-sm"
                  >
                    <option value="">Todos os atendentes</option>
                    {atendentesLista.map(function(at) {
                      return <option key={at.id} value={at.id}>{at.name}</option>;
                    })}
                  </select>
                </div>

                {/* Botão Buscar */}
                <div className="flex items-end">
                  <Button 
                    onClick={loadHistorico}
                    className="w-full h-9 bg-blue-600 hover:bg-blue-700"
                    disabled={loadingHistorico}
                  >
                    {loadingHistorico ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4 mr-1" />}
                    Buscar
                  </Button>
                </div>
              </div>

              {/* Campos de data (quando período = data) */}
              {historicoFiltros.periodo === 'data' && (
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="text-xs font-medium text-slate-600 mb-1 block">Data Início</label>
                    <Input
                      type="date"
                      value={historicoFiltros.dataInicio}
                      onChange={function(e) { 
                        setHistoricoFiltros(Object.assign({}, historicoFiltros, { dataInicio: e.target.value }));
                      }}
                      className="h-9"
                    />
                  </div>
                  <div>
                    <label className="text-xs font-medium text-slate-600 mb-1 block">Data Fim</label>
                    <Input
                      type="date"
                      value={historicoFiltros.dataFim}
                      onChange={function(e) { 
                        setHistoricoFiltros(Object.assign({}, historicoFiltros, { dataFim: e.target.value }));
                      }}
                      className="h-9"
                    />
                  </div>
                </div>
              )}
            </div>

            {/* Lista de Conversas */}
            <div className="flex-1 overflow-y-auto p-4">
              {loadingHistorico ? (
                <div className="flex items-center justify-center py-12">
                  <Loader2 className="w-8 h-8 animate-spin text-blue-500" />
                </div>
              ) : historicoConversas.length === 0 ? (
                <div className="text-center py-12 text-slate-500">
                  <History className="w-12 h-12 mx-auto mb-3 text-slate-300" />
                  <p className="font-medium">Nenhuma conversa encontrada</p>
                  <p className="text-sm mt-1">Ajuste os filtros e tente novamente</p>
                </div>
              ) : (
                <div className="space-y-2">
                  <p className="text-xs text-slate-500 mb-3">
                    {historicoConversas.length} conversa(s) encontrada(s)
                  </p>
                  {historicoConversas.map(function(conversa) {
                    return (
                      <div 
                        key={conversa.id}
                        className="p-3 rounded-lg border border-slate-200 hover:border-blue-300 hover:bg-blue-50 cursor-pointer transition-all"
                        onClick={function() {
                          setSelected(conversa);
                          setShowHistorico(false);
                          if (isMobile) setShowMobileChat(true);
                        }}
                      >
                        <div className="flex items-center justify-between">
                          <div className="flex items-center gap-3">
                            <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center">
                              <User className="w-5 h-5 text-slate-500" />
                            </div>
                            <div>
                              <p className="font-medium text-slate-800">
                                {conversa.nome_cliente || conversa.nome || conversa.telefone}
                              </p>
                              <p className="text-xs text-slate-500">
                                {conversa.telefone}
                                {conversa.atendente_nome && (
                                  <span className="ml-2 text-blue-600">• Atendente: {conversa.atendente_nome}</span>
                                )}
                              </p>
                            </div>
                          </div>
                          <div className="text-right">
                            <span className={
                              'text-xs px-2 py-1 rounded-full ' +
                              (conversa.status === 'finalizado' 
                                ? 'bg-green-100 text-green-700' 
                                : 'bg-slate-100 text-slate-600')
                            }>
                              {conversa.status === 'finalizado' ? 'Finalizado' : conversa.status}
                            </span>
                            <p className="text-xs text-slate-400 mt-1">
                              {conversa.updated_at 
                                ? new Date(conversa.updated_at).toLocaleDateString('pt-BR') + ' ' + new Date(conversa.updated_at).toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'})
                                : '-'
                              }
                            </p>
                          </div>
                        </div>
                        {conversa.ultima_mensagem && (
                          <p className="text-sm text-slate-500 mt-2 truncate">
                            {conversa.ultima_mensagem}
                          </p>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal de Configuração de Som */}
      {showConfigSom && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md">
            <div className="p-4 border-b bg-gradient-to-r from-slate-800 to-slate-900 text-white rounded-t-xl">
              <div className="flex items-center justify-between">
                <h3 className="font-bold flex items-center gap-2">
                  <Volume2 className="w-5 h-5" />
                  Configurações de Notificação
                </h3>
                <Button variant="ghost" size="sm" onClick={function() { setShowConfigSom(false); }} className="text-white hover:bg-white/20">
                  <X className="w-4 h-4" />
                </Button>
              </div>
            </div>
            
            <div className="p-4 space-y-4">
              {/* Toggle geral de som */}
              <div className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                <div>
                  <p className="font-medium text-slate-800">Som Ativado</p>
                  <p className="text-xs text-slate-500">Habilita ou desabilita todas as notificações sonoras</p>
                </div>
                <button
                  onClick={function() { setSomAtivado(!somAtivado); }}
                  className={'relative w-12 h-6 rounded-full transition-colors ' + (somAtivado ? 'bg-green-500' : 'bg-slate-300')}
                >
                  <span className={'absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ' + (somAtivado ? 'left-6' : 'left-0.5')} />
                </button>
              </div>

              {somAtivado && (
                <>
                  {/* Som para novo atendimento */}
                  <div className="flex items-center justify-between p-3 border rounded-lg">
                    <div>
                      <p className="font-medium text-slate-800">🆕 Novo Atendimento</p>
                      <p className="text-xs text-slate-500">Som quando um novo cliente inicia conversa</p>
                    </div>
                    <button
                      onClick={function() { setConfigSom({...configSom, novoAtendimento: !configSom.novoAtendimento}); }}
                      className={'relative w-12 h-6 rounded-full transition-colors ' + (configSom.novoAtendimento ? 'bg-blue-500' : 'bg-slate-300')}
                    >
                      <span className={'absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ' + (configSom.novoAtendimento ? 'left-6' : 'left-0.5')} />
                    </button>
                  </div>

                  {/* Som para cada mensagem recebida */}
                  <div className="flex items-center justify-between p-3 border rounded-lg">
                    <div>
                      <p className="font-medium text-slate-800">💬 Cada Mensagem Recebida</p>
                      <p className="text-xs text-slate-500">Som a cada nova mensagem do cliente</p>
                    </div>
                    <button
                      onClick={function() { setConfigSom({...configSom, novaMensagem: !configSom.novaMensagem}); }}
                      className={'relative w-12 h-6 rounded-full transition-colors ' + (configSom.novaMensagem ? 'bg-blue-500' : 'bg-slate-300')}
                    >
                      <span className={'absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ' + (configSom.novaMensagem ? 'left-6' : 'left-0.5')} />
                    </button>
                  </div>

                  {/* Som para atendimento sem interação */}
                  <div className="p-3 border rounded-lg space-y-3">
                    <div className="flex items-center justify-between">
                      <div>
                        <p className="font-medium text-slate-800">⏰ Alerta Sem Interação</p>
                        <p className="text-xs text-slate-500">Alerta quando atendimento fica sem resposta</p>
                      </div>
                      <button
                        onClick={function() { setConfigSom({...configSom, semInteracao: !configSom.semInteracao}); }}
                        className={'relative w-12 h-6 rounded-full transition-colors ' + (configSom.semInteracao ? 'bg-orange-500' : 'bg-slate-300')}
                      >
                        <span className={'absolute top-0.5 w-5 h-5 bg-white rounded-full shadow transition-transform ' + (configSom.semInteracao ? 'left-6' : 'left-0.5')} />
                      </button>
                    </div>
                    
                    {configSom.semInteracao && (
                      <div className="flex items-center gap-3 pt-2 border-t">
                        <span className="text-sm text-slate-600">Alertar após:</span>
                        <select
                          value={configSom.minutosInativo}
                          onChange={function(e) { setConfigSom({...configSom, minutosInativo: parseInt(e.target.value)}); }}
                          className="flex-1 border rounded px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                        >
                          <option value="2">2 minutos</option>
                          <option value="3">3 minutos</option>
                          <option value="5">5 minutos</option>
                          <option value="10">10 minutos</option>
                          <option value="15">15 minutos</option>
                          <option value="30">30 minutos</option>
                        </select>
                      </div>
                    )}
                  </div>

                  {/* Testar som */}
                  <div className="pt-2 border-t">
                    <Button 
                      variant="outline" 
                      size="sm" 
                      className="w-full"
                      onClick={function() { playNotificationSound(); toast.success('Som de teste!'); }}
                    >
                      🔊 Testar Som
                    </Button>
                  </div>
                </>
              )}
            </div>
            
            <div className="p-4 border-t bg-slate-50 rounded-b-xl">
              <Button 
                className="w-full bg-slate-800 hover:bg-slate-900" 
                onClick={function() { setShowConfigSom(false); }}
              >
                Fechar
              </Button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
